import { Injectable, isDevMode } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { CalendarEvent } from 'angular-calendar';
import { addMinutes } from 'date-fns';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { CheckboxField, Field, RECORD_CHAT, RECORD_DEAL, User } from '../../models';
import { FcmActionType } from '../../models/enums.model';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { FieldService } from '../field.service';
import { MessagingService } from '../messaging.service';
import { SessionService } from '../session.service';
import { AdminService } from '../admin.service';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { SummaryResolver } from '@angular/compiler';
import { filter } from 'rxjs/operator/filter';
import { CalendarService, ConditionService, ProjectService, TranslatorService } from '..';



@Injectable()
export class UscStoreService {

    public view_home: string = 'view_usc_home';
    public view_first: string = 'view_usc_first_impression';
    public view_middle: string = 'view_usc_middle_impression';
    public view_lasting: string = 'view_usc_lasting_impression';
    public view_search: string = 'view_usc_search_impression';
    public view_reports: string = 'view_usc_reports';
    public view_user_profile: string = 'view_usc_user_profile';
    public view_campaign_import: string = 'view_usc_campaign_import';
    public view_manage_campaigns: string = 'view_usc_manage_campaigns';
    public view_change_password: string = 'view_usc_change_password';
    public view_calendar: string = "view_usc_calendar";
    public view_sms_hosting: string = "view_usc_sms_hosting";
    public view_book_of_business: string = 'view_usc_book_of_business';
    public view_retail_foundations: string = 'view_usc_retail_foundations';
    // plan 2 win
    public view_plan_2_win: string = 'view_usc_plan_2_win';
    public view_plan_2_win_waiting: string = 'view_usc_plan_2_win_waiting';
    public view_p2w_daily_goal: string = 'view_usc_p2w_daily_goal';
    public view_p2w_todays_goal: string = 'view_usc_p2w_todays_goal';
    public view_p2w_todays_goal_table: string = 'view_usc_p2w_todays_goal_table';
    public view_p2w_action_plan: string = 'view_usc_p2w_action_plan';
    public view_p2w_action_plan_table: string = 'view_usc_p2w_action_plan_table';
    public view_p2w_action_plan_focus_actions: string = 'view_usc_p2w_action_plan_focus_actions';
    public view_p2w_action_plan_observation_notes: string = 'view_usc_p2w_action_plan_observation_notes';
    public view_p2w_action_plan_self_reflection: string = 'view_usc_p2w_action_plan_self_reflection';
    public view_p2w_action_plan_leader_feedback: string = 'view_usc_p2w_action_plan_leader_feedback';
    public view_p2w_action_plan_exec_feedback: string = 'view_usc_p2w_action_plan_exec_feedback';
    public view_p2w_prev_action_plan_table: string = 'view_usc_p2w_prev_action_plan_table';
    public view_p2w_prev_action_plan_focus_actions: string = 'view_usc_p2w_prev_action_plan_focus_actions';
    public view_p2w_prev_action_plan_observation_notes: string = 'view_usc_p2w_prev_action_plan_observation_notes';
    public view_p2w_prev_action_plan_self_reflection: string = 'view_usc_p2w_prev_action_plan_self_reflection';
    public view_p2w_prev_action_plan_leader_feedback: string = 'view_usc_p2w_prev_action_plan_leader_feedback';
    public view_p2w_prev_action_plan_exec_feedback: string = 'view_usc_p2w_prev_action_plan_exec_feedback';
    public view_p2w_previous_action_plans: string = 'view_usc_p2w_previous_action_plans';
    public view_p2w_team_action_plan: string = 'view_usc_p2w_team_action_plan';
    public view_p2w_prev_action_plan: string = 'view_usc_p2w_prev_action_plan';
    public view_p2w_this_action_plan: string = 'view_usc_p2w_this_action_plan';
    public view_p2w_next_action_plan: string = 'view_usc_p2w_next_action_plan';
    public view_p2w_payout_estimator: string = 'view_usc_p2w_payout_estimator';
    public view_p2w_payout_estimator_table: string = 'view_usc_p2w_payout_estimator_table';
    public view_p2w_payout_estimator_forecast_table: string = 'view_usc_p2w_payout_estimator_forecast_table';
    public view_p2w_payout_estimator_goal_table: string = 'view_usc_p2w_payout_estimator_goal_table';
    public view_p2w_sales_tracker: string = 'view_usc_p2w_sales_tracker';
    public view_p2w_team_sales_tracker: string = 'view_usc_p2w_team_sales_tracker';
    // public view_p2w_dashboards: string = 'view_usc_p2w_dashboards';
    public view_p2w_scorecard: string = 'view_usc_p2w_scorecard';
    public view_p2w_plan_2_win: string = 'view_usc_p2w_plan_2_win';
    public view_p2w_detail_results: string = 'view_usc_p2w_detail_results';
    public view_p2w_sales_scorecard: string = 'view_usc_p2w_sales_scorecard';
    public view_p2w_associate_gross_adds_detail_results: string = 'view_usc_p2w_associate_quota_gross_adds_details';
    public view_p2w_associate_accessory_detail_results: string = 'view_usc_p2w_associate_quota_accessory_details';
    public view_p2w_goal_gross_adds_detail_results: string = 'view_usc_p2w_goal_gross_adds_details';
    public view_p2w_goal_accessory_detail_results: string = 'view_usc_p2w_goal_accessory_details';
    public view_p2w_quota_gross_adds_detail_results: string = 'view_usc_p2w_quota_gross_adds_details';
    public view_p2w_quota_accessory_detail_results: string = 'view_usc_p2w_quota_accessory_details';
    public view_p2w_sales_quota_achievements: string = 'view_usc_p2w_sales_vs_quota_achievements';
    public view_p2w_sales_goal_achievements: string = 'view_usc_p2w_sales_vs_goal_achievements';
    public view_p2w_todays_sales_goal_achievements: string = 'view_usc_p2w_todays_sales_vs_goal_achievements';
    public view_p2w_store_sales_quota_achievements: string = 'view_usc_p2w_store_sales_vs_quota_achievements';
    public view_p2w_store_todays_sales_quota_achievements: string = 'view_usc_p2w_store_todays_sales_vs_quota_achievements';
    public view_p2w_team_this_action_plans: string = 'view_usc_p2w_team_this_action_plans';
    public view_p2w_team_next_action_plans: string = 'view_usc_p2w_team_next_action_plans';
    public view_p2w_associate_detailed_results: string = 'view_usc_p2w_associate_detailed_results';
    public view_p2w_associate_todays_detailed_results: string = 'view_usc_p2w_associate_todays_detailed_results';
    public view_p2w_other_results: string = 'view_usc_p2w_other_results';
    public view_p2w_todays_other_results: string = 'view_usc_p2w_todays_other_results';
    public view_p2w_awarded_users: string = 'view_usc_data_awarded_users';
    // gamification
    public view_p2w_competition_status: string = 'view_usc_p2w_competition_status';
    public view_p2w_competitions: string = 'view_usc_p2w_competitions';
    public view_p2w_challenges: string = 'view_usc_p2w_challenges';
    public view_p2w_my_competitions: string = 'view_usc_p2w_my_competitions';
    public view_p2w_my_challenges: string = 'view_usc_p2w_my_challenges';
    public view_p2w_my_points: string = 'view_usc_p2w_my_points';
    public view_p2w_my_badges: string = 'view_usc_p2w_my_badges';
    // store visits 
    public view_usc_store_visits: string = 'view_usc_store_visits';
    public view_store_visit_checkin: string = 'view_usc_store_visit_checkin';
    public view_store_visit_waiting_appt: string = 'view_usc_store_visit_waiting_appt';
    public view_store_visit_scheduled_appt: string = 'view_usc_store_visit_scheduled_appt';
    public view_store_visit_serving_now: string = 'view_usc_store_visit_serving_now';
    public view_store_visit_service_completed: string = 'view_usc_store_visit_service_completed';
    public view_store_scheduling_setup: string = 'view_usc_store_scheduling_setup';
    public view_store_hours_table: string = 'view_usc_store_hours_table';
    public view_no_appt_dates_table: string = 'view_usc_no_appt_dates_table';
    // uploaded documents
    public view_uploaded_documents: string = 'view_usc_uploaded_documents';
    public view_uscc_document_list: string = 'view_usc_uscc_document_list';

    // 1st impression
    //public form_interested: string = "view_usc_form_schedule_appointment";
    public form_interested: string = "view_usc_form_interested";
    public form_not_interested: string = "view_usc_form_not_interested";
    public form_call_back: string = "view_usc_form_call_back";
    public form_lvm_no_answer: string = "view_usc_form_lvm_no_answer";
    public form_connected_call: string = "view_usc_form_connected_call";
    public form_connected_vm_na: string = "view_usc_form_connected_vm_na";
    public form_update_info: string = "view_usc_form_update_info";
    // middle impression
    public form_purchase: string = "view_usc_form_purchase";
    public form_future_sale: string = "view_usc_form_future_sale";
    public form_no_purchase: string = "view_usc_form_no_purchase";
    public form_reschedule: string = "view_usc_form_reschedule";
    public form_new_call: string = "view_usc_form_new_call";
    // lasting impression
    public form_last_interested: string = "view_usc_form_last_interested";
    public form_last_not_interested: string = "view_usc_form_last_not_interested";
    public form_last_call_back: string = "view_usc_form_last_call_back";
    // new lead
    public form_first_impression: string = "view_usc_form_first_impression";
    public form_middle_impression: string = "view_usc_form_middle_impression";
    public form_lasting_impression: string = "view_usc_form_lasting_impression";
    public form_quick_sale: string = "view_usc_form_quick_sale";
    public form_olr_internal_referral: string = "view_usc_form_internal_referral";
    // new check-in
    public form_svt_bill_payment: string = "view_usc_form_store_visit_bill_payment";
    public form_svt_sales_associate: string = "view_usc_form_store_visit_sales_associate";
    public form_svt_appointment: string = "view_usc_form_first_impression";
    // file upload
    public form_file_upload: string = "view_usc_form_file_upload";
    // customer chats
    public view_customer_chats: string = "view_usc_data_customer_chats";
    // calendar events
    public view_call_events: string = "view_usc_data_call_events";
    public view_meeting_events: string = "view_usc_data_meeting_events";
    public view_area_meeting_events: string = "view_usc_data_area_meeting_events";
    public view_store_visit_team_stores: string = "view_usc_data_store_visit_team_stores";
    // actions
    public action_accept_appointment: string = "action_usc_accept_appointment";
    public action_save_to_middle: string = "action_usc_save_to_middle";
    public action_no_answer: string = "action_usc_lvm_no_answer";
    public action_no_show_archive: string = "action_usc_no_show_archive";
    public action_move_to_first: string = "action_usc_move_to_first";
    public action_move_to_lasting: string = "action_usc_move_to_lasting";
    public action_mass_archive: string = "action_usc_archive";
    public action_mass_reassign: string = "action_usc_reassign";
    public action_auto_reassign: string = "action_usc_auto_reassign";
    public action_update_associate: string = "action_usc_update_associate";
    public action_send_optin_request: string = "action_usc_send_optin_request";
    public action_mark_chat_as_read: string = "action_usc_mark_chat_as_read";
    public action_update_language_preference: string = "action_usc_update_language_preference";
    public action_update_book_of_business: string = "action_usc_update_book_of_business";
    public action_action_plan_approval: string = "action_usc_action_plan_approval";
    public action_action_plan_approved: string = "action_usc_action_plan_approved";
    public action_action_plan_rejected: string = "action_usc_action_plan_rejected";
    public action_has_current_month_quota_changed: string = "action_usc_has_current_month_quota_changed";
    public action_approved_action_plan_updated: string = "action_usc_approved_action_plan_updated";
    public action_daily_goal_submission: string = "action_usc_daily_goal_submission";
    public action_multinotes_update: string = "action_usc_multinotes_update";
    public action_this_month_ap_reminder: string = "action_usc_this_month_ap_reminder";
    public action_next_month_ap_reminder: string = "action_usc_next_month_ap_reminder";
    public action_quick_sale_order_id_query: string = "action_usc_quick_sale_order_id_query";
    public action_usc_quick_sale_deletion: string = "action_usc_quick_sale_deletion";
    public action_update_churn_resolution: string = "action_usc_update_churn_resolution";
    public action_update_days_scheduled: string = "action_usc_update_days_scheduled";
    public action_update_days_worked: string = "action_usc_update_days_worked";
    public action_update_todays_goal: string = "action_usc_update_todays_goal";
    public action_get_this_month_action_plan: string = "action_usc_get_this_month_action_plan";
    public action_get_next_month_action_plan: string = "action_usc_get_next_month_action_plan";
    public action_update_this_month_action_plan: string = "action_usc_update_this_month_action_plan";
    public action_update_next_month_action_plan: string = "action_usc_update_next_month_action_plan";
    public action_todays_goal_submission: string = "action_usc_todays_goal_submission";
    public action_this_month_action_plan_submission: string = "action_usc_this_month_action_plan_submission";
    public action_next_month_action_plan_submission: string = "action_usc_next_month_action_plan_submission";
    public action_svt_move_by_offset: string = 'action_usc_svt_move_by_offset';
    public action_svt_checkin_customer: string = 'action_usc_svt_checkin_customer';
    public action_svt_start_serving: string = 'action_usc_svt_start_serving';
    public action_update_store_hours: string = "action_usc_update_store_hours";
    public action_update_no_appt_dates: string = "action_usc_update_no_appt_dates";

    // notification type
    public notification_type_deal_assignment: "notification_deal_assignment";
    public action_deal_assignment_accepted = "deal_assignment_accepted";
    public action_deal_assignment_rejected = "deal_assignment_rejected";
    public action_deal_assignment_timeout = "deal_assignment_timeout";
    // dialog type
    public dialog_type_no_show: string = "dlg_no_show";
    public dialog_type_new_referral: string = "dlg_new_referral";
    public dialog_type_compose_email: string = "dlg_compose_email";
    public dialog_type_attachments: string = "dlg_attachments";
    public dialog_type_do_not_call: string = "dlg_do_not_call";
    public dialog_type_edit_associate: string = "dlg_edit_associate";
    public dialog_type_custom_msg: string = "dlg_custom_msg";
    public dialog_type_optin_request: string = "dlg_optin_request";
    public dialog_type_associate_required: string = "dlg_associate_required";
    public dialog_type_language_preference: string = "dlg_language_preference";
    public dialog_type_not_interested: string = "dlg_not_interested";
    public dialog_type_yes_no_prompt: string = "dlg_yes_no_prompt";
    public dialog_type_ok_prompt: string = "dlg_ok_prompt";
    public dialog_type_same_day_appt_alert: string = "dlg_same_day_appt_alert";
    public dialog_type_action_plan_approval_warning: string = "dlg_action_plan_approval_warning";
    public dialog_type_action_plan_reminder: string = "dlg_action_plan_reminder";
    public dialog_type_quick_sale_details: string = "dlg_quick_sale_details";
    public dialog_type_appointment_assignment: string = "dlg_appointment_assignment";
    public dialog_type_churn_resolution: string = "dlg_churn_resolution";
    public dialog_type_welcome_message: string = "dlg_welcome_message";
    public dialog_type_user_awards: string = "dlg_user_awards";
    public dialog_type_svt_adjust_queue_position: string = "dlg_svt_adjust_queue_position";
    public dialog_type_svt_end_service_outcome: string = "dlg_svt_end_service_outcome";
    public dialog_type_svt_appointment_check_in: string = "dlg_svt_appointment_check_in";

    // dialog response
    public response_move_to_first: string = "response_move_to_first";
    public response_move_to_lasting: string = "response_move_to_lasting";
    public response_record_purchase: string = "response_record_purchase";
    public response_archive: string = "response_archive";
    public response_new_referral: string = "response_new_referral";
    public response_compose_email: string = "response_compose_email";
    public response_do_not_call: string = "response_do_not_call";
    public response_edit_associate: string = "response_edit_associate";
    public response_first_to_lasting: string = "response_first_to_lasting";
    public response_optin_request_en: string = "response_optin_request_en";
    public response_optin_request_fr: string = "response_optin_request_fr";
    public response_optin_request_es: string = "response_optin_request_es";
    public response_action_plan_reminder: string = "response_action_plan_reminder";
    public response_quick_sale_save: string = "response_action_quick_sale_save";
    public response_appt_accept: string = "response_action_appt_accept";
    public response_appt_skip: string = "response_action_appt_skip";
    public response_edit_churn_resolution: string = "response_edit_churn_resolution";
    public response_welcome_message: string = "response_welcome_message";
    public response_user_awards: string = "response_user_awards";
    public response_adjust_queue_position: string = "response_adjust_queue_position";
    public response_svt_end_service_purchase: string = "response_svt_end_service_purchase";
    public response_svt_end_service_no_purchase: string = "response_svt_end_service_no_purchase";
    public response_svt_appointment_check_in: string = "response_svt_appointment_check_in";
    public response_svt_appointment_start_serving: string = "response_svt_appointment_start_serving";

    // form response
    public form_response_save_to_middle: string = "save_to_middle";
    public form_response_save_to_first: string = "save_to_first";
    public form_response_save_and_new: string = "save_and_new";
    public form_response_save_purchase: string = "save_purchase";

    // error code
    public error_code_missing_quota: number = -1002;

    private form_mappings: any = {
        interested: this.form_interested,
        not_interested: this.form_not_interested,
        call_back: this.form_call_back,
        no_answer: this.form_lvm_no_answer,
        purchase: this.form_purchase,
        no_purchase: this.form_no_purchase,
        reschedule: this.form_reschedule,
        last_interested: this.form_last_interested,
        last_not_interested: this.form_last_not_interested,
        last_call_back: this.form_last_call_back,
        first_impression: this.form_first_impression,
        middle_impression: this.form_middle_impression,
        lasting_impression: this.form_lasting_impression
    };

    private viewData: any = {};
    private gotoItemSubject = new ReplaySubject<any>(1);
    public gotoItem = this.gotoItemSubject.asObservable();
    private currentViewSubject = new ReplaySubject<string>(1);
    public currentView = this.currentViewSubject.asObservable();
    private currentViewValue: string;
    private searchTextSubject = new ReplaySubject<string>(1);
    public searchText = this.searchTextSubject.asObservable();
    private openUserChatSubject = new ReplaySubject<any>(1);
    public openUserChat = this.openUserChatSubject.asObservable();
    private currentViewItemsSubject = new ReplaySubject<any>(1);
    public currentViewItems = this.currentViewItemsSubject.asObservable();
    private viewItemUpdatedSubject = new ReplaySubject<any>(1);
    public viewItemUpdated = this.viewItemUpdatedSubject.asObservable();
    private updatedViewItemsSubject = new ReplaySubject<any>(1);
    public updatedViewItems = this.updatedViewItemsSubject.asObservable();
    private triggerChatItemReloadSubject = new ReplaySubject<boolean>();
    public triggerChatItemReload = this.triggerChatItemReloadSubject.asObservable();

    constructor(
        public adminService: AdminService,
        public translatorService: TranslatorService,
        private titleService: Title,
        private apiService: ApiService,
        private authService: AuthService,
        private fieldService: FieldService,
        private sanitizer: DomSanitizer,
        private sessionService: SessionService,
        private messagingService: MessagingService,
        private calendarService: CalendarService,
        private projectService: ProjectService,
        public conditionService: ConditionService,
    ) {
    }

    isReportAllowed() {
        var user = this.authService.getAuth();
        if (this.isUSCellTelesales()) return this.getItemCustomFieldValue(user, "Custom Portal Reporting") == "Yes";
        return (this.getItemCustomFieldValue(user, "Custom Portal Reporting") == "Yes" || (!this.isUSCellTelesales() && user.administrator_level == "1"));
    }

    isCustomerTextMessagingEnabled(): boolean {
        //return false;
        var user = this.authService.getAuth();
        if (!this.isSMSEnabled()) return false;
        return (this.getItemCustomFieldValue(user, "Enable Customer Text Messaging") == "Yes");
    }

    isCustomerSMSNotificationDisabled(): boolean {
        var user = this.authService.getAuth();
        return (this.getItemCustomFieldValue(user, "SMS Notification Disabled") == "Yes");
    }

    isClientCodeEnabled(code: string): boolean {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf(code) >= 0);
    }

    getItemCustomFieldValue(item, field): string {
        var custom_fields = item.custom_fields ? item.custom_fields : item.json_custom_fields ? JSON.parse(item.json_custom_fields) : null;
        if (custom_fields) {
            var field = custom_fields.find(f => f.CustomFieldName == field);
            if (field) return field.CustomFieldValue;
        }
        return null;
    }

    setItemCustomFieldValue(item, field, value) {
        if (item.json_custom_fields) {
            var custom_fields = JSON.parse(item.json_custom_fields);
            var field = custom_fields.find(f => f.CustomFieldName == field);
            if (field) { field.CustomFieldValue = value; }
            item.json_custom_fields = JSON.stringify(custom_fields);
        }
        if (item.custom_fields) {
            var field = item.custom_fields.find(f => f.CustomFieldName == field);
            if (field) { field.CustomFieldValue = value; }
        }
    }

    // getTrainingVideoLinks() {
    //     let links: any[] = [];
    //     if (this.isUSCellCorp) {
    //         links.push({ label: "Introduction", link: "https://vimeo.com/salesnow/review/279937684/944a68143f" });
    //         links.push({ label: "First Impression", link: "https://vimeo.com/salesnow/review/279937403/8765ff825b" });
    //         links.push({ label: "Middle Impression", link: "https://vimeo.com/salesnow/review/279937496/d2c0e349c4" });
    //         links.push({ label: "Lasting Impression", link: "https://vimeo.com/salesnow/review/279937550/43d5caf446" });
    //         links.push({ label: "Searching", link: "https://vimeo.com/salesnow/review/279937729/0c39127f6f" });
    //         // iPad
    //         links.push({ label: "Calling Leads on iPad", link: "https://drive.google.com/file/d/1E8auUf-sr_YOPNC3H4L3mn7jfwaIrrhE/view?usp=sharing_eil_se_dm&ts=64f7dea4" });
    //         links.push({ label: "Messaging Leads on iPad", link: "https://drive.google.com/file/d/1ly9aDcKKQgC05f1x0REKhODO0fc2ymSi/view?usp=sharing_eil_se_dm&ts=64f7de97" });
    //         links.push({ label: "Recording Activity Outcomes on iPad", link: "https://drive.google.com/file/d/1a6-BCSF62rq2q2rng64vwR3m-kNAZoM-/view?usp=sharing_eil_se_dm&ts=64f7de75" });
    //         links.push({ label: "Recording Store Visits on iPad", link: "https://drive.google.com/file/d/11O5BUS57IZfcboSSnVRxTiioGZareHXp/view?usp=sharing_eil_se_dm&ts=64f7de64" });
    //         links.push({ label: "Searching for and Creating New Leads on iPad", link: "https://drive.google.com/file/d/1FdnQva11B5Rp1kAlWIr7GvyKq0_XAfyk/view?usp=sharing_eil_se_dm&ts=64f7de53" });
    //         links.push({ label: "Navigating Leads on iPad", link: "https://drive.google.com/file/d/1zKc3EYhLm8nxRBW5N5hdKfbOAonQOgA_/view?usp=sharing_eil_se_dm&ts=64f7de88" });
    //         links.push({ label: "Plan2Win on SalesNOW iPad", link: "https://drive.google.com/file/d/1-ouCWDcwbiiRqK2RUtVaLa8I4Z76P3bs/view?usp=sharing_eil_se_dm&ts=64f64657" });
    //         links.push({ label: "Sales Scorecard on SalesNOW iPad", link: "https://drive.google.com/file/d/1tHyfayyTCIaO-BJvoEHYFJokLwSRk79i/view?usp=sharing_eil_se_dm&ts=64f6467a" });
    //         links.push({ label: "Accepting Appointments on SalesNOW iPad", link: "https://drive.google.com/file/d/1-B94gNTtOn7QxbLwPt6ptRJm2KbGGTD9/view?usp=sharing_eil_se_dm&ts=64f64695" });
    //     } else {
    //         links.push({ label: "Introduction", link: "https://vimeo.com/salesnow/review/279937656/f33118afb7" });
    //         links.push({ label: "First Impression", link: "https://vimeo.com/salesnow/review/279937366/8b2285b736" });
    //         links.push({ label: "Middle Impression", link: "https://vimeo.com/salesnow/review/279937456/7458d8470e" });
    //         links.push({ label: "Lasting Impression", link: "https://vimeo.com/salesnow/review/279937523/33ad91830a" });
    //         links.push({ label: "Searching", link: "https://vimeo.com/salesnow/review/279937704/41cb7d6b79" });
    //     }
    //     return links;
    // }

    getWebTrainingVideoLinks() {
        let links: any[] = [];
        links.push({ label: "SalesNOW Introduction and Basic Navigation", link: "https://www.salesnow.com/static/uscellular/training/General Training/SalesNOW Introduction and Basic Navigation - Corporate Retail.mp4" });                     // COL 1
        if (this.isLeader()) links.push({ label: "This Month's Action Plans", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/This Month's Action Plans - Leader.mp4" });                 // COL 2 - P2W leader 
        if (!this.isLeader()) links.push({ label: "This Month's Action Plan", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/This Months Action Plan - Associate.mp4" });                 // COL 2 - P2W member
        links.push({ label: "Making Calls and Managing First Impression", link: "https://www.salesnow.com/static/uscellular/training/General Training/Making Calls and Managing First Impression - Corporate Retail.mp4" });                     // COL 1
        if (this.isLeader()) links.push({ label: "Next Month's Action Plans", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Next Month's Action Plans - Leader.mp4" });                 // COL 2 - P2W leader 
        if (!this.isLeader()) links.push({ label: "Next Month's Action Plan", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Next Months Action Plan - Associate.mp4" });                 // COL 2 - P2W member
        links.push({ label: "Managing Customer Visits in the Middle Impression", link: "https://www.salesnow.com/static/uscellular/training/General Training/Managing Customer Visits in the Middle Impression - Corporate Retail.mp4" });              // COL 1
        links.push({ label: "Today's Goals", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Today's Goals.mp4" });                                                  // COL 2
        links.push({ label: "Managing Follow-Up Iinteractions in Lasting Impression", link: "https://www.salesnow.com/static/uscellular/training/General Training/Managing follow up interactions in Lasting Impression - Corporate Retail v4.mp4" });          // COL 1
        if (this.isLeader()) links.push({ label: "Scorecard", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Scorecard.mp4" });                                 // COL 2 - P2W leader 
        if (!this.isLeader()) links.push({ label: "Sales Tracker", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Sales Tracker.mp4" });                            // COL 2 - P2W member
        links.push({ label: "Searching for and Adding New Customers in SalesNOW", link: "https://www.salesnow.com/static/uscellular/training/General Training/Searching for and Adding New Customers in SalesNOW - Corporate Retail.mp4" });             // COL 1
        if (this.isLeader()) links.push({ label: "Plan2Win", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Plan2Win.mp4" });                                  // COL 2 - P2W leader
        links.push({ label: "Sending SMS Messages", link: "https://www.salesnow.com/static/uscellular/training/General training/Sending SMS Messages.mp4" });                                           // COL 1
        links.push({ label: "Payout Estimator", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Payout Estimator.mp4" });                                               // COL 2 - P2W
        links.push(null);  // COL 1
        links.push({ label: "Quick Sale", link: "https://www.salesnow.com/static/uscellular/training/P2W Training/Quick Sale.mp4" });
        links.push(null);  // COL 1

        return links;
    }

    getiPadTrainingVideoLinks() {
        let links: any[] = [];
        if (!this.isUSCellAgent()) links.push({ label: "Calling Leads on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Calling Leads.mp4" });
        links.push({ label: "Messaging Leads on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Messaging Leads.mp4" });
        links.push({ label: "Recording Activity Outcomes on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Recording Activity Outcomes.mp4" });
        links.push({ label: "Recording Store Visits on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Recording Store Visits.mp4" });
        links.push({ label: "Searching for and Creating New Leads on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Searching for and Creating New Leads.mp4" });
        links.push({ label: "Navigating Leads on iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Navigating the Leads Tab.mp4" });
        if (!this.isUSCellAgent()) links.push({ label: "Plan2Win on SalesNOW iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Plan2Win on SalesNOW iPad App.mp4" });
        if (!this.isUSCellAgent()) links.push({ label: "Sales Scorecard on SalesNOW iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Sales Scorecard on SalesNOW iPad app.mp4" });
        links.push({ label: "Accepting Appointments on SalesNOW iPad", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Accepting Appointments on SalesNOW iPad app.mp4" });
        if (this.isLeader()) links.push({ label: "Leader Overview", link: "https://www.salesnow.com/static/uscellular/training/iPad%20Training/SalesNOW%20iPad%20App%20-%20Leader%20Overview.mp4" });  // COL 2 - P2W leader
        links.push({ label: "Switching Teams with SalesNOW iPad App", link: "https://www.salesnow.com/static/uscellular/training/iPad Training/Switching Teams with SalesNOW iPad App.mp4" })
        return links;
    }

    getQueueingTrainingVideoLinks() {
        return this.training_videos.queueing_training;
    }

    getTrainingVideoLinks() {
        return this.training_videos;
    }

    isLeader() {
        var user = this.authService.getAuth();
        return (user && user.team_role == "L");
    }

    isStore() {
        var user = this.authService.getAuth();
        return (user && user.title == "Store");
    }

    isStoreMgrOrAssistant() {
        var user = this.authService.getAuth();
        switch (user.title) {
            case 'Mgr Sales':
            case 'Mgr Store':
            case 'Store Mgr I':
            case 'Store Mgr II':
            case 'Assistant Manager':
                return true;
        }
        return false;
    }

    isTelesalesManager() {
        var user = this.authService.getAuth();
        switch (user.title) {
            case 'Mgr Telesales':
            case 'Telesales Supervisor':
                return true;
        }
        return false;
    }

    isExec() {
        var user = this.authService.getAuth();
        switch (user.title) {
            case 'Area VP-General Mgr, Retail Sales & Ops':
            case 'AVP/GM Retail Sales and Operations':
            case 'Dir Retail Sales and Operations':
            case 'Mgr Retail Area Sales':
                return true;
            case 'Master':
            case 'Admin/Manager of Agency':
            case 'Area Manager':
                return true;
        }
        return false;
    }

    isAdmin() {
        var user = this.authService.getAuth();
        return (user && user.administrator_level == "1");
    }

    isP2WEnabled(): boolean {
        var bClientEnabled = (this.isUSCellTelesales() || this.isUSCellCorp() || this.isUSCellAgent()) && !this.isAdmin();
        var bUserEnabled = this.getItemCustomFieldValue(this.authService.getAuth(), "P2W Enabled") == "Yes";
        var bUserDisabled = this.getItemCustomFieldValue(this.authService.getAuth(), "P2W Enabled") == "No";
        return !bUserDisabled && bClientEnabled && (isDevMode() || bUserEnabled);
    }

    isStoreVisitTabEnabled(): boolean {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("_ESVT_") >= 0);
    }

    isRetailFoundationsEnabled(): boolean {
        return this.getItemCustomFieldValue(this.authService.getAuth(), "Enable Retail Foundations") == "Yes";
    }

    getDefaultSearchScope(filter_type) {
        if (filter_type == 'u_user_ID') {
            var user = this.authService.getAuth();
            return { label: `${user.first_name} ${user.last_name}`, value: `${user.ID}` };
        }
        return null;
    }

    getDefaultCampaignFilter() {
        var user = this.authService.getAuth();
        var campaign_filter = { label: "All Campaigns", value: "" };

        var default_campaign = this.getItemCustomFieldValue(user, 'Default Campaign Filter');
        switch (default_campaign) {
            case '':
            case null:
            case '[System Default]':
                if (this.isUSCellCorp() && this.isLeader()) {
                    switch (user.title) {
                        case "Store Mgr I":
                        case "Store Mgr II":
                        case "Mgr Sales":
                        case "Assistant Manager":
                        case "Mgr Store":
                            break;
                        default:
                            campaign_filter = { label: "Walk-In", value: "Walk-In" };
                            if (this.isUSCellTelesales) campaign_filter = { label: "Incoming Call", value: "Incoming Call" };
                            if (this.isUSCellInsideSales) campaign_filter = { label: "Associate", value: "Associate" };
                            break;
                    }
                }
                break;
            case 'All Campaigns':
                break;
            default:
                campaign_filter = { label: default_campaign, value: default_campaign };
                break;
        }
        return campaign_filter;
    }

    isUSCellRetail() {
        var user = this.authService.getAuth();
        return (user && user.client_code && (user.client_code.indexOf("USCELL-RETAIL-CORP") >= 0 || user.client_code.indexOf("USCELL-RETAIL-AGENT") >= 0));
    }

    isUSCellCorp() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-CORP") >= 0);
    }

    isUSCellAgent() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-AGENT") >= 0);
    }

    isUSCellInsideSales() {
        var user = this.authService.getAuth();
        return (user && user.client_code && (user.client_code.indexOf("USCELL-RETAIL-INSIDESALES") >= 0 || user.client_code.indexOf("USCELL-RETAIL-TELESALES") >= 0));
    }

    isUSCellTelesales() {
        var user = this.authService.getAuth();
        return (user && user.client_code && user.client_code.indexOf("USCELL-RETAIL-TELE_SALES") >= 0);
    }

    isFcmPushCommandEnabled(): boolean {
        if (this.sessionService.isIOSDevice()) return false;
        var user = this.authService.getAuth();
        var isSMSNotificationDisabled = this.isCustomerSMSNotificationDisabled();
        var isPushCommandDisabled = this.isClientCodeEnabled("_USCPCD_");
        var messagingNotificationEnabled = this.messagingService.messagingNotificationEnabled.getValue();
        if (isSMSNotificationDisabled || !messagingNotificationEnabled) return false;
        if (!environment.production) return true;
        return (!isPushCommandDisabled && messagingNotificationEnabled);
    }

    isSMSEnabled(): boolean {
        if (!environment.production) return true;
        return !this.isClientCodeEnabled("_USCSMSD_");
    }

    isMultiLanguageEnabled(): boolean {
        var user = this.authService.getAuth();
        if (!environment.production) return true;
        return (user && user.client_code && user.client_code.indexOf("_USCMLD_") < 0);
    }

    isCensorshipEnabled(): boolean {
        var user = this.authService.getAuth();
        if (!environment.production) return true;
        return (user && user.client_code && user.client_code.indexOf("_USCCSD_") < 0);
    }

    setGotoItem(item) {
        this.gotoItemSubject.next(item);
    }

    setSearchText(searchText) {
        this.searchTextSubject.next(searchText);
    }

    setCurrentView(view) {
        this.currentViewValue = view;
        this.currentViewSubject.next(view);
    }

    setCurrentViewItems(items) {
        this.currentViewItemsSubject.next(items);
    }

    getCurrentView() {
        return this.currentViewValue;
    }

    setViewItemUpdated(item, bReloadItem = false) {
        if (bReloadItem) {
            this.reloadItem(item).subscribe(result => {
                if (result && result.items && result.items.length != 0) {
                    this.viewItemUpdatedSubject.next(result.items[0]);
                }
            });
        } else {
            this.viewItemUpdatedSubject.next(item);
        }
    }

    reloadItem(item): Observable<any> {
        if (item) {
            var dl_ID = item.new_dl_ID ? item.new_dl_ID : item.dl_ID;
            var idList = [dl_ID];
            var params: any = {
                idList: idList,
                p: 1,
                ps: idList.length,
                ob: "dl_ID",
                text: '',
                obd: "asc",
                est: "ST_Search",
            }

            return this.getData(this.view_search, params);
        }
    }

    isItemInCurrentView(item) {
        var deal = this.currentViewItems.find(i => i.dl_ID == item.dl_ID);
        return deal ? true : false;
    }

    setUpdatedViewItems(items) {
        this.updatedViewItemsSubject.next(items);
    }

    setOpenUserChat(item) {
        this.openUserChatSubject.next(item);
    }

    getMetaData(view, params, bRefresh: boolean = false): Observable<any> {
        if (!this.viewData[view] || !this.viewData[view].meta_data || bRefresh) {
            return this.apiService.get("/views/" + view + "/metadata", params).map((result) => {
                this.setMetaData(view, result);
                // object cloning to prevent referencing issues
                return JSON.parse(JSON.stringify(result));
            }
            )
        } else {
            return new Observable(observer => {
                //console.log(this.viewData[view]);
                observer.next(this.viewData[view]);
                observer.complete();
            });
        }
    }

    getData(view, params, bResetIdleTimer: boolean = true, bUseWeb3Api: boolean = false): Observable<any> {
        if (bUseWeb3Api) {
            return this.apiService.web3_get("/views/" + view, params, bResetIdleTimer).map(
                (result) => {
                    this.setData(view, result);
                    return result;
                }
            )
        } else {
            return this.apiService.get("/views/" + view, params, bResetIdleTimer).map(
                (result) => {
                    this.setData(view, result);
                    return result;
                }
            )
        }
    }

    setMetaData(view, data) {
        this.viewData[view] = {
            meta_data: data.meta_data
        };
    }

    setData(view, data) {
        this.viewData[view] = {
            result: data
        }
    }

    saveData(view: string, id: number, data: any) {
        if (id == 0) {
            return this.apiService.put("/views/" + view, data, "raw").map(
                (result) => { return result; }
            )
        } else {
            return this.apiService.post("/views/" + view + "/" + id, data, "raw").map(
                (result) => { return result; }
            )
        }
    }

    getFormFields(viewFields: any, data): Array<Field<any>> {
        let formFields: Array<Field<any>> = this.fieldService.configToFormFields(viewFields);
        if (formFields && data) {
            formFields.forEach(f => {
                if (f.display_type == CheckboxField.control_type && f.checked) f.value = "Yes";
                if (data[f.key]) {
                    f.value = data[f.key];
                }
            });
        }
        return formFields;
    }

    updateDataWithFormValues(formFields: Array<Field<any>>, data) {
        if (formFields && data) {
            formFields.forEach(f => {
                if (f.value) {
                    data[f.key] = f.value;
                }
            });
        }
        return data;
    }

    formFieldsToViewItem(formFields: Array<Field<any>>) {
        let item: Object = {};
        formFields.forEach(f => {
            item[f.key] = f.value;
        });

        return item;
    }

    processActionOnViewItems(view: string, action: string, params: any) {
        return this.apiService.get(`/views/${view}/actions/${action}`, params).map(
            (result) => { return result; }
        )
    }

    processActionOnViewItem(view: string, id: number, action: string, params: any) {
        return this.apiService.get(`/views/${view}/${id}/actions/${action}`, params).map(
            (result) => { return result; }
        )
    }

    processActionOnViewItemOnPost(view: string, id: number, action: string, data: any, params: any) {
        // return this.apiService.get(`/views/${view}/${id}/actions/${action}`, params).map(
        //     (result) => { return result; }
        // )
        return this.apiService.post(`/views/${view}/${id}/actions/${action}`, data, "raw", params).map(
            (result) => { return result; }
        )
    }

    saveOutcome(view: string, id: number, formFields: Array<Field<any>>, params: any = null) {
        if (id == 0 || view == this.form_future_sale) {
            return this.apiService.put("/views/" + view, formFields, "raw", params).map(
                (result) => { return result; }
            )
        } else {
            return this.apiService.post("/views/" + view + "/" + id, formFields, "raw", params).map(
                (result) => { return result; }
            )
        }
    }

    getView(view: string, params: any): string {
        if (params) {
            return this.form_mappings[params.outcome];
        }
        return "";
    }

    getViewByItem(item) {
        var view;
        switch (item.dl_type) {
            case "First Impression": view = this.view_first; break;
            case "Middle Impression": view = this.view_middle; break;
            case "Lasting Impression": view = this.view_lasting; break;
        }
        return view;
    }

    smsCensorship: any;
    loadSmsCensorship(): Observable<any> {
        let params: any = {
            it: "client_preference",
            iid: 0,
            fn: "sms_censorship"
        };
        return this.apiService.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    this.smsCensorship = JSON.parse(result[0].field_value);
                    this.sessionService.log(this.smsCensorship);
                    this.smsCensorship.content_uc = [];
                    this.smsCensorship.content.forEach(c => {
                        this.smsCensorship.content_uc.push(c.toUpperCase());
                    })
                }
                return this.smsCensorship;
            }
        )
    }

    training_videos: any = {};
    private trainingVideosReadySubject = new ReplaySubject<boolean>(0);
    public trainingVideosReady = this.trainingVideosReadySubject.asObservable();

    loadTrainingVideos(): Observable<any> {
        if (this.isLeader()) {
            return this.loadLeaderTrainingVideos();
        } else {
            return this.loadMemberTrainingVideos();
        }
    }

    loadLeaderTrainingVideos(): Observable<any> {
        let params: any = {
            it: "client_preference",
            iid: 0,
            fn: "usc_leader_resource_video_links_web"
        };
        return this.apiService.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    var training_videos = JSON.parse(result[0].field_value);
                    this.sessionService.log(this.training_videos);
                    this.training_videos.queueing_training = [];
                    this.training_videos.p2w_training = [];
                    this.training_videos.ipad_training = [];
                    this.training_videos.general_training = [];
                    training_videos.forEach(c => {
                        switch (c.group) {
                            case "Queueing Training": this.training_videos.queueing_training.push(c); break;
                            case "P2W Training Videos": this.training_videos.p2w_training.push(c); break;
                            case "iPad Training Videos": this.training_videos.ipad_training.push(c); break;
                            case "General Training Videos": this.training_videos.general_training.push(c); break;
                        }
                    })
                    this.trainingVideosReadySubject.next(true);
                }
                return this.training_videos;
            }
        )
    }

    loadMemberTrainingVideos(): Observable<any> {
        let params: any = {
            it: "client_preference",
            iid: 0,
            fn: "usc_member_resource_video_links_web"
        };
        return this.apiService.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    var training_videos = JSON.parse(result[0].field_value);
                    this.sessionService.log(this.training_videos);
                    this.training_videos.queueing_training = [];
                    this.training_videos.p2w_training = [];
                    this.training_videos.ipad_training = [];
                    this.training_videos.general_training = [];
                    training_videos.forEach(c => {
                        switch (c.group) {
                            case "Queueing Training": this.training_videos.queueing_training.push(c); break;
                            case "P2W Training Videos": this.training_videos.p2w_training.push(c); break;
                            case "iPad Training Videos": this.training_videos.ipad_training.push(c); break;
                            case "General Training Videos": this.training_videos.general_training.push(c); break;
                        }
                    })
                    this.trainingVideosReadySubject.next(true);
                }
                return this.training_videos;
            }
        )
    }

    p2w_detail_info: any;
    loadP2wDetailInfo(): Observable<any> {
        let params: any = {
            it: "client_preference",
            iid: 0,
            fn: "p2w_detail_info"
        };
        return this.apiService.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    this.p2w_detail_info = JSON.parse(result[0].field_value);
                    console.log(this.p2w_detail_info);
                }
                return this.p2w_detail_info;
            }
        )
    }

    isSmsSafe(message: string): boolean {
        if (this.smsCensorship && this.smsCensorship.content && message) {
            var message_uc = message.toUpperCase().replace(/ +(?= )/g, '');                            // replace double spaces
            var message_w_sp = message.toUpperCase().replace(/[^a-z]/gi, ' ').replace(/ +(?= )/g, '');    // replace all non alpha numeric character with space
            var message_no_sp = message.toUpperCase().replace(/[^a-z]/gi, '').replace(/ +(?= )/g, '');  // remove all non alpha numeric character 
            var message_words = message_uc.split(' ');
            var message_words_w_sp = message_w_sp.split(' ');
            var message_words_no_sp = message_no_sp.split(' ');
            for (var i = 0; i < this.smsCensorship.content_uc.length; i++) {
                var censored_phrase = this.smsCensorship.content_uc[i];
                var phrase_w_sp = censored_phrase.indexOf(' ') > 0;
                if (message_words.indexOf(censored_phrase) >= 0) return false;                        //ie. fuck
                if (phrase_w_sp && message_uc.indexOf(censored_phrase) >= 0) return false;            //
                if (phrase_w_sp && message_w_sp.indexOf(censored_phrase) >= 0) return false;          //ie. Mother Fucker
                if (phrase_w_sp && message_no_sp.indexOf(censored_phrase) >= 0) return false;         //ie. M$o$ther Fu$c$ker
                if (message_words_w_sp.indexOf(censored_phrase) >= 0) return false;                   //
                if (message_words_no_sp.indexOf(censored_phrase) >= 0) return false;                  //ie. F$U$C$K
            }
        }
        return true;
    }

    emailTemplates: any;
    loadEmailTemplates(): Observable<any> {
        return this.apiService.get("/models/email_templates").map(
            (result) => {
                this.emailTemplates = result;
                return this.emailTemplates;
            }
        )
    }

    getSmsTemplates(category) {
        if (category == null || category == '') category = "English";
        var smsTemplates = this.getEmailTemplatesByType("SMS");
        var templates = smsTemplates;
        if (category && category.length > 0) {
            templates = [];
            smsTemplates.forEach(t => {
                if (t.sub_type == category) templates.push(t);
            })
        }
        return templates;
    }

    getEmailTemplatesByType(type) {
        let templates: Array<any> = [];
        this.emailTemplates.forEach(
            t => {
                if (t.type.indexOf(type) >= 0) {
                    templates.push(t);
                }
            }
        )
        return templates;
    }

    getEmailTemplatesByView(view, curr_event) {
        let templates: Array<any> = [];
        this.emailTemplates.forEach(
            t => {
                if (t.name.indexOf('USC') >= 0 && t.type == 'Email') {
                    switch (curr_event) {
                        case "event_usc_cc_positive":
                        case "event_usc_cc_neutral":
                        case "event_usc_cc_negative":
                        case "event_usc_cc_voicemail":
                        case "event_usc_cc_no_answer":
                            if (t.sub_type == "Connected Call") templates.push(t);
                            break;
                        default:
                            if (t.sub_type != "Connected Call") templates.push(t);
                    }
                }
            }
        )
        return templates;
    }

    translateSmsTemplate(template_ID, record_type, item_id): Observable<any> {
        return this.translateEmailTemplate(template_ID, record_type, item_id);
    }

    translateEmailTemplate(template_ID, record_type, item_id): Observable<any> {
        return this.apiService.get(`/models/email_templates/${template_ID}/translate/${record_type}/${item_id}`).map(
            result => {
                return result;
            }
        )
    }

    translateSmsTemplates(record_type, item_ID, templates: any[]): Observable<any> {
        return this.translateEmailTemplates(record_type, item_ID, templates);
    }

    translateEmailTemplates(record_type, item_ID, templates: any[]): Observable<any> {
        // [WebGet(UriTemplate = "/models/{record_type}/{item_id}/email_templates/translate?qs={qs}")]
        var id_list = [];
        templates.forEach(t => id_list.push(t.ID));
        let qs: any = { id_list: id_list };
        let params: any = { qs: JSON.stringify(qs) };
        return this.apiService.get(`/models/${record_type}/${item_ID}/email_templates/translate`, params).map(
            result => {
                return result;
            }
        )
    }

    sendEmailTemplate(template, attachments: any[], params = null) {
        var attachment_IDs: any[] = [];
        if (attachments) {
            attachments.forEach(a => { attachment_IDs.push(a.ID); });
        }
        if (params == null) params = {};
        params.attachment_IDs = attachment_IDs.join(",");
        return this.apiService.put(`/models/email_templates/send`, template, "json", params).map(
            result => {
                return result;
            }
        )
    }

    getViewItem(view: string, item_ID: number): Observable<any> {
        return this.apiService.get("/views/" + view + "/" + item_ID).map(
            (result) => {
                return result;
            }
        )
    }

    getViewConditions(view: string, params = null): Observable<any> {
        return this.getMetaData(view, params).map(
            (result) => {
                // object cloning to prevent referencing issues
                return JSON.parse(JSON.stringify(result.meta_data.conditions));
            }
        )
    }

    processListItems(view: string, item: any, field: any, list_items: any[], formField: Field<any>[]) {
        let filtered_list_items = JSON.parse(JSON.stringify(list_items));
        let drViews = [this.form_interested, this.form_call_back, this.form_reschedule];
        let nlcViews = [this.form_middle_impression, this.form_lasting_impression];


        // follow up meeting/appointment time slots
        if (field.key == "cfd_fumts") {
            var cfd_fumd = formField.find(f => f.key == "cfd_fumd");
            if (cfd_fumd && cfd_fumd.value && cfd_fumd.value.target) {
                filtered_list_items = this.getAvailableTimeSlots(cfd_fumd.value.target.value, filtered_list_items, this.calendar_events);
            }
            else {
                filtered_list_items.length = 0;
            }
        }
        // follow up call time slots
        // we need to remove any invalid time slots from this field,
        // to do so we need to get the select follow up call date, then compare with existing calendar events 
        else if (field.key == "cfd_fucts") {
            var cfd_fucd = formField.find(f => f.key == "cfd_fucd");
            if (cfd_fucd && cfd_fucd.value && cfd_fucd.value.target) {
                filtered_list_items = this.getAvailableTimeSlots(cfd_fucd.value.target.value, filtered_list_items, this.calendar_events);
            }
            else {
                filtered_list_items.length = 0;
            }
        }
        // store visit date range and call back date range
        else if ((field.key == "cfd_sv" || field.key == "cfd_cb") && drViews.indexOf(view) >= 0) {
            let cm_archive_date: any = null;
            if (item.cfd_ad) {
                // NOTE: here, time zone is irrelevant in calculation and comparison
                let space_index = item.cfd_ad.indexOf(' ');
                let date_tokens = item.cfd_ad.substring(0, space_index).split('/');
                // construct the date by parts for accuracy
                cm_archive_date = new Date(date_tokens[2], date_tokens[0] - 1, date_tokens[1]);
            } else if (item.cm_end_date) {
                let date_tokens = item.cm_end_date.split('-');
                // construct the date by parts for accuracy
                cm_archive_date = new Date(date_tokens[0], date_tokens[1] - 1, date_tokens[2]);
            }

            if (cm_archive_date) {
                cm_archive_date = Date.parse(cm_archive_date);
                filtered_list_items = [];
                list_items.forEach(
                    li => {
                        var range = li.value.replace(" Days", "");
                        var tokens = range.split("-");
                        var today = new Date();
                        var day_offset = today.getDate() + parseInt(tokens[0]);
                        var start_date = today.setDate(day_offset);  // convert to int for numeric addition over string concatenation
                        if (start_date < cm_archive_date) {
                            filtered_list_items.push(li);
                        }
                    }
                )
                if (filtered_list_items.length == 0) { filtered_list_items.push(list_items[0]); }
            }
        }
        // new lead campaign (was previously in use, now it is driven by the custom field)
        else if (field.key == "cfd_nlc" && nlcViews.indexOf(view) >= 0) {
            filtered_list_items = [];
            list_items.forEach(li => { filtered_list_items.push(li); });
        }
        // update display with value descriptions
        else if (field.key == "dl_olr_ct") {
            for (var i = 0; i < filtered_list_items.length; i++) {
                switch (filtered_list_items[i].value) {
                    case "BiR":
                    case "SMB":
                        filtered_list_items[i].text = "SMB (Company with 1 - 499, not in Public Sector)"; break;
                    case "Public Sector": filtered_list_items[i].text = "Public Sector (Government Schools, Libraries, Utilities)"; break;
                    case "Enterprise": filtered_list_items[i].text = "Enterprise (Company with 500+)"; break;
                }
            }
        } else if (field.key == "dl_sub_type") {
            filtered_list_items = [];
            filtered_list_items.push({ text: "Regular", value: "Regular" });
            filtered_list_items.push({ text: "Charge Back", value: "Charge Back" });
        }

        return filtered_list_items;
    }

    // we need to remove any invalid time slots from this field,
    // to do so we need to get the selected schedule date, then compare with existing calendar events 
    getAvailableTimeSlots(schedule_date: any, time_slots: any[], scheduled_events: any[]) {
        var now = new Date();
        var date_parts = schedule_date.split('-');
        var selected_date = new Date(date_parts[0], date_parts[1] - 1, date_parts[2]);
        var now_date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        if (selected_date.getTime() < now_date.getTime()) {
            time_slots.length = 0;
        } else {
            // remove any scheduled time slots for the selected_date
            for (var i = 0; i < scheduled_events.length; i++) {
                var e = scheduled_events[i];
                // e_date is ISO8601 formatted (event_date should be instantiated as the user's local time date)
                var event_date = new Date(e.e_date);
                // compare in string value to avoid compare in Date value (UTC is a mess)
                let month_value: any = event_date.getMonth() + 1;
                month_value = (month_value < 10) ? '0' + month_value.toString() : month_value.toString();
                let date_value: any = event_date.getDate();
                date_value = (date_value < 10) ? '0' + date_value.toString() : date_value.toString();
                if (schedule_date == `${event_date.getFullYear()}-${month_value}-${date_value}`) {
                    // cfd_fucts/insidesales: follow up call time slot
                    // cfd_fumts/retail: follow up meeting/appointment time slot
                    var time_slot = !this.isUSCellRetail() ? e.cfd_fucts : e.cfd_fumts;
                    var index_to_remove = time_slots.findIndex(li => li.value == time_slot);
                    if (index_to_remove >= 0) time_slots.splice(index_to_remove, 1);
                }
            }

            if (selected_date.getTime() == now_date.getTime()) {
                var past_time_slots = [];
                time_slots.forEach(i => {
                    if (i && i.value) {
                        var start = i.value.split('-')[0]; // extract the start time from '9:00 AM - 9:30 AM'
                        var start_hours = parseInt(start.substr(0, start.indexOf(':'))); // extract the hour form '9:00 AM '
                        var start_minutes = parseInt(start.substr(start.indexOf(':') + 1, 2)) // extract the minute form '9:00 AM '
                        if (start_hours != 12 && start.indexOf('PM') >= 0) start_hours += 12; // add 12 hours if past 1 
                        var time_slot = addMinutes(now_date, start_hours * 60 + start_minutes);
                        if (time_slot < now) past_time_slots.push(i); // remove any starting time slot that is in the past
                    }
                });
                past_time_slots.forEach(s => {
                    var index_to_remove = time_slots.findIndex(li => li.value == s.value);
                    if (index_to_remove >= 0) time_slots.splice(index_to_remove, 1);
                })
            }
        }
        return time_slots;
    }

    uploadViewItemFile(view, id, file: File): Observable<any> {
        const _formData = new FormData();
        _formData.append('filename', file.name);
        _formData.append('file', file);
        // console.log(_formData);
        return this.apiService.postFile(`/views/${view}/${id}/files/upload`, _formData).map(
            result => {
                console.log(result);
            }
        )
    }

    getSalesNOWSanitizedUrl(user: User, url: string, loginRequired: boolean): SafeResourceUrl {
        var auth = `un=${user.username}&auth_token=${user.session_token}`;
        var qs = encodeURI(`&ReturnUrl=${url}`);
        var loginUrl = `${environment.sn_url}/login.aspx?${auth}${qs}`;
        var directUrl = `${environment.sn_url}${url}`;
        // determine whether login is required
        var url = loginRequired ? loginUrl : directUrl;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    getSalesNOWSanitizedHtml(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    private last_login_time: Date = null;
    setLastLoginDateTime(datetime: Date) {
        this.last_login_time = datetime;
    }

    getLastLoginDateTime(): Date {
        return this.last_login_time;
    }

    private xml_special_to_escaped_one_map: any = {
        '&': '&amp;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;'
    };

    private escaped_one_to_xml_special_map: any = {
        '&amp;': '&',
        '&quot;': '"',
        '&lt;': '<',
        '&gt;': '>'
    };

    public encodeXml(string) {
        return string.replace(/([\&"<>])/g, function (str, item) {
            return this.xml_special_to_escaped_one_map[item];
        });
    }

    public decodeXml(string) {
        return string.replace(/(&quot;|&lt;|&gt;|&amp;)/g,
            function (str, item) {
                return this.escaped_one_to_xml_special_map[item];
            });
    }

    public isCustomerChatPullMsg(currentUser: User, message): boolean {
        if (currentUser && message && message.data && message.data.actions) {
            var actions = JSON.parse(message.data.actions);
            var customer_pull_action = actions.find(a => a.action_type == FcmActionType.ServerAction && a.record_type == RECORD_CHAT && a.actionID == "pull" && a.pin == currentUser.ID);
            if (customer_pull_action) {
                return true;
            }
        }
        return false;
    }

    public isTelesalesDealAssignment(currentUser: User, message): boolean {
        if (currentUser && message && message.data && message.data.actions) {
            var actions = JSON.parse(message.data.actions);
            var customer_pull_action = actions.find(a => a.action_type == FcmActionType.ServerAction && a.record_type == RECORD_DEAL && a.actionID == "assign" && a.pin == currentUser.ID);
            if (customer_pull_action) {
                if (customer_pull_action.detail && customer_pull_action.detail.cmd_sub_type == "ts_deal_assignment") {
                    return true;
                }
            }
        }
        return false;
    }

    public isQtracDealAssignment(currentUser: User, message): boolean {
        if (currentUser && message && message.data && message.data.actions) {
            var actions = JSON.parse(message.data.actions);
            var customer_pull_action = actions.find(a => a.action_type == FcmActionType.ServerAction && a.record_type == RECORD_DEAL && a.actionID == "assign" && a.pin == currentUser.ID);
            if (customer_pull_action) {
                if (customer_pull_action.detail && customer_pull_action.detail.cmd_sub_type == "qtrac_assignment") {
                    return true;
                }
            }
        }
        return false;
    }

    public setTriggerChatItemReload(): void {
        this.triggerChatItemReloadSubject.next(true);
    }

    // Team Open/0000 Sr VP - Sales: Sr VP - Sales								
    // Team Eric Jagher: VP Sales Corporate Owned Retail							
    // Team Christopher Rathsack: Sr Director of Sales						
    // Team Erryn Andersen: Dir of Sales Corp-Owned Channel					
    // Team Ellena Sanchez: Mgr Retail Area Sales				
    // Team Brandon Darby: Mgr Store			
    // Team Triangle Mall Store - 3167		

    public getChatPullInterval(currentUser: User): number {
        var minute = 60 * 1000;
        if (this.isUSCellCorp() && currentUser.title.indexOf("Consultant") >= 0) return 10 * 1000;    // 10s (consultants)
        if (this.isUSCellAgent()) {
            switch (currentUser.title) {
                case 'Store':
                case "Associate":
                case "Manager":
                case "Area Manager":
                    return 10 * 1000;
            }
        }
        var interval = parseInt(this.getItemCustomFieldValue(currentUser, "Chat Pull Interval (sec)"));
        if (!isNaN(interval)) return interval < 0 ? 10 * 1000 : interval * 1000;

        switch (currentUser.title) {
            case "Mgr Store":
            case "Mgr Sales":
            case "ASDM":
            case "Admin/Manager of Agency":
            case "Master":
                return 1 * minute;
            case "Sr VP - Sales":
            case "VP Sales Corporate Owned Retail":
            case "Sr Director of Sales":
            case "Dir of Sales Corp-Owned Channel":
            case "Mgr Retail Area Sales":
            default:
                return 2 * minute;
        }
    }

    public setTitle(title: string, bShowDot: boolean = false): void {
        this.titleService.setTitle(title);
        if (bShowDot) {
            this.messagingService.setFavicon('assets/img/sn/favicon-dotted.ico');
            this.messagingService.playSound();
        } else {
            this.messagingService.setFavicon('favicon.ico');
        }
    }

    // deal assignment messages - begin
    private assignmentMessagesSubject = new BehaviorSubject<any[]>(null);
    public assignmentMessages = this.assignmentMessagesSubject.asObservable();
    public addAssignmentMessage(new_msg) {
        var messages = this.assignmentMessagesSubject.getValue();
        if (messages == null) messages = [];
        var match = messages.find(m => m.fcmMessageId == new_msg.fcmMessageId);
        // can't find match by fcmMessageId, but still need to check item_ID just in case firebase resend the msg
        if (match == null) {
            var new_actions = JSON.parse(new_msg.data.actions);
            var assignment_types = ["ts_deal_assignment", "qtrac_assignment"];
            var new_assignment = new_actions.find(a => assignment_types.indexOf(a.detail.cmd_sub_type) >= 0);
            for (var i = 0; i < messages.length; i++) {
                var actions = JSON.parse(messages[i].data.actions);
                var assignment = actions.find(a => assignment_types.indexOf(a.detail.cmd_sub_type) >= 0);
                if (assignment && new_assignment && assignment.detail.item_ID == new_assignment.detail.item_ID) {
                    match = messages[i];
                }
            }
        }
        if (match == null) {
            messages.push(new_msg);
            this.assignmentMessagesSubject.next(messages);
        }
        // TODO: remove message after expiration
    }

    public removeAssignmentMessage(message) {
        var messages = this.assignmentMessagesSubject.getValue();
        if (messages) {
            var index = messages.findIndex(m => m.fcmMessageId == message.fcmMessageId);
            // var index = -1;
            // for (var i = 0; i < messages.length; i++) {
            //   if (JSON.stringify(message) == JSON.stringify(messages[i])) {
            //     index = i; break;
            //   }
            // }
            if (index >= 0) messages.splice(index, 1);
            this.assignmentMessagesSubject.next(messages);
        }
    }

    // deal assignment messages - end

    // calendar methods - begin
    // private areaCalendarEventsSubject = new BehaviorSubject<any[]>(null);
    // public areaCalendarEvents = this.areaCalendarEventsSubject.asObservable();
    // private area_calendar_events: any[] = [];
    // private bLoadingAreaMeetingEvents: boolean = false;

    // public reloadAreaCalendarEvents(action: string) {
    //     // if (!this.bLoadingCallEvents && !this.isUSCellRetail()) {
    //     //     this.bLoadingCallEvents = true;
    //     //     this.apiService.getViewData(this.view_call_events, { est: "ST_Search" }).subscribe(
    //     //         result => {
    //     //             this.calendar_events = this.calendar_events.concat(result.items);
    //     //             this.calendarEventsSubject.next(this.calendar_events);
    //     //             this.bLoadingCallEvents = false;
    //     //         },
    //     //         err => {
    //     //             console.log(err);
    //     //         }
    //     //     );
    //     // }

    //     if (!this.bLoadingAreaMeetingEvents && this.isUSCellRetail()) {
    //         this.bLoadingMeetingEvents = true;
    //         this.apiService.getViewData(this.view_area_meeting_events, { est: "ST_Search" }).subscribe(
    //             result => {
    //                 this.area_calendar_events = this.area_calendar_events.concat(result.items);
    //                 this.areaCalendarEventsSubject.next(this.area_calendar_events);
    //                 this.bLoadingAreaMeetingEvents = false;
    //             },
    //             err => {
    //                 console.log(err);
    //             }
    //         );
    //     }
    // }

    private calendarEventsSubject = new ReplaySubject<any[]>(null);
    public calendarEvents = this.calendarEventsSubject.asObservable();
    private calendar_events: any[] = [];
    private bLoadingCallEvents: boolean = false;
    private bLoadingMeetingEvents: boolean = false;

    public isLoadingCalendarEvents() { return this.bLoadingCallEvents || this.bLoadingMeetingEvents };

    public reloadCalendarEvents(action: string) {
        if (!this.bLoadingCallEvents && !this.isUSCellRetail()) {
            this.bLoadingCallEvents = true;
            this.apiService.getViewData(this.view_call_events, { est: "ST_Search" }).subscribe(
                result => {
                    this.calendar_events = result.items;
                    //this.calendar_events = this.calendar_events.concat(result.items);
                    this.calendarEventsSubject.next(this.calendar_events);
                    this.bLoadingCallEvents = false;
                },
                err => {
                    console.log(err);
                }
            );
        }

        if (!this.bLoadingMeetingEvents && this.isUSCellRetail()) {
            this.bLoadingMeetingEvents = true;
            var user = this.authService.getAuth();
            var cross_access_enabled = this.getItemCustomFieldValue(user, 'Cross-Store Calendar Access') == 'Yes';
            var isCrossStoreScopeEnabled = this.isUSCellCorp() && cross_access_enabled;
            var view = isCrossStoreScopeEnabled && this.isStoreMgrOrAssistant() ? this.view_area_meeting_events : this.view_meeting_events;
            //var view = this.view_meeting_events;
            this.apiService.getViewData(view, { est: "ST_Search" }).subscribe(
                result => {
                    this.calendar_events = result.items;
                    // this.calendar_events = this.calendar_events.concat(result.items);
                    this.calendarEventsSubject.next(this.calendar_events);
                    this.bLoadingMeetingEvents = false;
                },
                err => {
                    console.log(err);
                }
            );
        }
    }

    public getStoreUnassignedSameDayLeads() {
        var count = 0;
        if (this.calendar_events) {
            var today = new Date();
            this.calendar_events.forEach(e => {
                if (e.u_title == "Store") {
                    var event_date = new Date(e.e_date);
                    if (event_date.toString().substring(0, 16) == today.toString().substring(0, 16) && e.dl_account_type == '') count++;
                }
            })
        }
        return count;
    }

    public getCalendarEvents() {
        return this.calendar_events;
    }

    public getViewItemFromEvent(event: CalendarEvent): any {
        return this.calendar_events.find(e => e.calendar_event == event);
    }
    // calendar methods - end

    // qtrac meeting methods - start
    public getAppointmentTimeSlots(date) {
        this.apiService.processMeetingAction("qtrac_get_appt_timeslots", date, "raw").subscribe(
            timeslots => {
                console.log('qtrac_get_appt_timeslots succeed', timeslots);
            },
            err => {
                console.log('qtrac_get_appt_timeslots failed', err);
                this.sessionService.log("unable to get timeslots");
            }
        )
    }
    // qtrac meeting methods - end

    // #region action plans and daily goals - start
    public action_plan_status_draft = 1;
    public action_plan_status_requested = 2;
    public action_plan_status_approved = -1;
    public action_plan_status_rejected = -2;
    public action_plan_status_mapping = {
        "1": "Draft",
        "2": "Submitted for Approval",
        "-1": "Approved",
        "-2": "Rejected",
    }

    public daily_goal_status_draft = 1;
    public daily_goal_status_submitted = -1;

    public isActionPlanRequired() {
        return !this.isUSCellAgent();
    }

    public isActionPlanSubmitted(action_plan) {
        if (action_plan) {
            return action_plan.ap_status == this.action_plan_status_approved || action_plan.ap_status == this.action_plan_status_requested ||
            action_plan.cs_status == this.action_plan_status_approved || action_plan.cs_status == this.action_plan_status_requested;
        }
        return false;
    }

    action_plan_batch_loaded_count: number = 0;                      // tracks number of batches loaded
    max_action_plan_batches: number = 12;                           // 1 year of past action plans
    action_plans_by_month: any = {};
    private is_previous_action_plans_loaded: boolean = false;
    private previousActionPlansLoadedSubject = new ReplaySubject<boolean>(0);
    public previousActionPlansLoaded = this.previousActionPlansLoadedSubject.asObservable();
    // load last 12 months of action plans
    public loadPreviousActionPlans(bReload: boolean = false) {
        if (!bReload && !this.is_previous_action_plans_loaded) {
            var current_month_subject = this.getThisMonthActionPlanSubject();
            var batch_start_month = parseInt(current_month_subject);        // ie. 202304
            if (bReload) {
                this.action_plans_by_month = {};
                this.is_previous_action_plans_loaded = false;
            }

            this.action_plan_batch_loaded_count = 0;
            var batch_count = 0;
            for (var i = 0; i < this.max_action_plan_batches; i++) {
                var batch_end_month = batch_start_month;
                batch_start_month = batch_start_month - 1;
                if (batch_start_month.toString().endsWith('00')) {
                    batch_start_month = batch_start_month - 100 + 12;   // ie. 202300 - 100 + 12 = 202212
                    batch_end_month = batch_start_month + 100 - 12;     // ie. 202213 + 100 - 12 = 202301; 
                }

                if (batch_start_month >= 202212) {
                    batch_count++;
                    if (this.action_plans_by_month[batch_start_month.toString()]) continue;
                    var params = { est: 'ST_Search', "SP_START_MONTH_SUBJECT": batch_start_month.toString(), 'SP_END_MONTH_SUBJECT': batch_end_month.toString() };
                    this.apiService.getViewData(this.view_p2w_previous_action_plans, params).subscribe(result => {
                        if (result.items && result.items.length > 0) {
                            this.action_plans_by_month[result.items[0].cs_subject] = result.items;
                            if (Object.keys(this.action_plans_by_month).length == batch_count) {
                                this.previousActionPlansLoadedSubject.next(true);
                                this.is_previous_action_plans_loaded = true;
                            }
                        }
                    });
                }
            }

            // evaluate previousActionPlansLoaded status here in case all batches were loaded by the user one by one  
            if (Object.keys(this.action_plans_by_month).length == batch_count) {
                this.previousActionPlansLoadedSubject.next(true);
                this.is_previous_action_plans_loaded = true;
            }
        }
    }

    public loadActionPlansByMonth(month: string): Observable<any> {
        if (this.action_plans_by_month[month]) {
            return new Observable(observer => {
                observer.next(this.action_plans_by_month[month]);
                observer.complete();
            });
        } else {
            var batch_start_month = parseInt(month);
            var batch_end_month = batch_start_month + 1;
            var params = { est: 'ST_Search', "SP_START_MONTH_SUBJECT": batch_start_month.toString(), 'SP_END_MONTH_SUBJECT': batch_end_month.toString() };
            return this.apiService.getViewData(this.view_p2w_previous_action_plans, params).map(result => {
                if (result.items && result.items.length > 0) {
                    this.action_plans_by_month[result.items[0].cs_subject] = result.items;
                    return result.items;
                }
            });
        }
    }

    public loadFilterMetaDeta(month: number) {
        var batch_start_month = month;
        var batch_end_month = batch_start_month + 1;
        if (batch_start_month.toString().endsWith('00')) {
            batch_start_month = batch_start_month - 100 + 12;   // ie. 202300 - 100 + 12 = 202212
            batch_end_month = batch_start_month + 100 - 12;     // ie. 202213 + 100 - 12 = 202301; 
        }

        var params = { est: 'ST_Search', "SP_START_MONTH_SUBJECT": batch_start_month.toString(), 'SP_END_MONTH_SUBJECT': batch_end_month.toString() };
        this.apiService.getViewData(this.view_p2w_previous_action_plans, params).map(result => {
            this.action_plans_by_month[result.items[0].cs_subject] = result.items;
            if (Object.keys(this.action_plans_by_month).length == this.max_action_plan_batches) {
                this.previousActionPlansLoadedSubject.next(true);
            }
        })
    }

    available_action_plan_months: any[] = [];
    public getAvailableActionPlanMonths(user) {
        var available_months = [];
        if (this.p2w_detail_info && this.p2w_detail_info.available_months) {
            available_months = this.p2w_detail_info.available_months;
        } else {
            var this_year_this_month = parseInt(this.getThisMonthActionPlanSubject());  // ie. 202309
            var last_year_this_month = this_year_this_month - 100;                      // ie. 202309 - 100 = 202209
            var month_index = this_year_this_month;                                     // ie. 202309
            while (month_index > last_year_this_month) {
                if (month_index % 100 == 0) month_index += 12;                          // ie. 202200 -> 202200 + 12 = 202212
                available_months.push(month_index.toString());
                var month_index = month_index - 1;                                      // ie. { 202309, 202308, 202307, ..., 202209 }
            }
        }

        available_months.sort(function (a, b) {
            return (a < b) ? 1 : -1;
        })

        // if (this.action_plans_by_month) {
        //     var available_months = Object.keys(this.action_plans_by_month);
        //     available_months.push(this.getThisMonthActionPlanSubject());
        //     // sort month descending
        //     available_months.sort(function (a, b) {
        //         return (a < b) ? 1 : -1;
        //     })
        // }
        return available_months.slice(0, 12);
    }

    public getPreviousUserActionPlanByID(id: number): any {
        for (var month in this.action_plans_by_month) {
            var user_action_plan = this.action_plans_by_month[month].find(ap => ap.cs_ID == id);
            if (user_action_plan) return user_action_plan;
        }
        //var user_action_plan = this.previous_action_plans.find(ap => ap.cs_ID == id);
        //return user_action_plan;
        return null;
    }

    // public title_to_scope_type_mapping = [
    //     // corporate mapping
    //     { title: "VP - Retail Sales and Operations", scope_type: "channel" },
    //     { title: "Area VP-General Mgr, Retail Sales & Ops", scope_type: "avp_team" },
    //     { title: "Dir Retail Sales and Operations", scope_type: "dos_team" },
    //     { title: "Mgr Retail Area Sales", scope_type: "asm_team" },
    //     { title: "Store Mgr I", scope_type: "store_team" },
    //     { title: "Store Mgr II", scope_type: "store_team" },
    //     { title: "Mgr Store", scope_type: "store_team" },
    //     { title: "Mgr Sales", scope_type: "store_team" },
    //     { title: "Assistant Manager", scope_type: "store_team" },
    //     // telesales mapping
    //     { title: "VP - Customer Support", scope_type: "channel" },
    //     { title: "Mgr Telesales", scope_type: "store_team" },
    //     { title: "Telesales Supervisor", scope_type: "store_team" },
    //     // { title: "Telesales Supervisor2", scope_type: "store" },
    // ];

    public getAllPreviousActionPlans(user) {
        var previous_action_plans = [];
        for (var month in this.action_plans_by_month) {
            previous_action_plans = previous_action_plans.concat(this.action_plans_by_month[month]);
        }

        //var active_user_scope = this.getActionPlanUserScope(user)
        // if (user.team_role == "L") active_user_scope = this.getDefaultAchievementScopeTeam(user);
        var active_user_scope = this.getDefaultAchievementScopeTeam(user);
        var user_action_plans = [];
        previous_action_plans.forEach(ap => {
            if (ap[active_user_scope.scope_type] == active_user_scope.scope_value || (active_user_scope.scope_type == 'channel' && this.isUSCellTelesales())) {
                user_action_plans.push(ap);
            }
        })
        if (active_user_scope.scope_type == 'ur_username') {
            user_action_plans.sort(function (a, b) {
                return (a.cs_subject < b.cs_subject) ? 1 : -1;
            });
        }

        return user_action_plans;
    }

    public getPreviousUserActionPlanByMonth(user: any, scope_month: string): any {
        // var user_action_plan = this.previous_action_plans.find(ap => ap.cs_subject == scope_month && ap.ur_user_ID == parseInt(user.ID));
        var user_action_plan = this.action_plans_by_month[scope_month].find(ap => ap.ur_user_ID == parseInt(user.ID));
        if (user_action_plan) {
            var sales_vs_quotas = JSON.parse(user_action_plan.cs_sales_vs_quotas);
            if (sales_vs_quotas) {
                user_action_plan.mtd_postpaid_handset_volume = sales_vs_quotas.postpaid_handset_volume;
                user_action_plan.mtd_other_volume = sales_vs_quotas.other_volume;
                user_action_plan.mtd_bir = sales_vs_quotas.bir;
                user_action_plan.mtd_accessories_revenue = sales_vs_quotas.accessory_revenue;
                user_action_plan.mtd_other_revenue = sales_vs_quotas.other_revenue;
                user_action_plan.mtd_upgrades = sales_vs_quotas.upgrades;
                user_action_plan.mtd_high_msrp_accessories = sales_vs_quotas.high_msrp_accessories;
                user_action_plan.mtd_device_trade_ins = sales_vs_quotas.device_trade_ins;
            } else {
                return null;
            }
        }
        return user_action_plan;
    }

    public getPreviousUserSalesVsQuotaAchievement(user: any, scope_month: string) {
        var user_action_plan = this.getPreviousUserActionPlanByMonth(user, scope_month);
        return (user_action_plan) ? JSON.parse(user_action_plan.cs_sales_vs_quotas) : null;
    }

    public getPreviousUserSalesVsGoalAchievement(user: any, scope_month: string) {
        var user_action_plan = this.getPreviousUserActionPlanByMonth(user, scope_month);
        return (user_action_plan) ? JSON.parse(user_action_plan.cs_sales_vs_goals) : null;
    }

    public getConsultantAchievementsFromPreviousActionPlans(month: string, scope_type: string, scope_value: string, quota_or_goal: string) {
        var achievements = [];
        var action_plans_by_month = this.action_plans_by_month[month];
        action_plans_by_month.forEach(ap => {
            //this.previous_action_plans.forEach(ap => {
            if (ap.ur_title != 'Store' && ap.cs_subject == month) {
                var rep_sales = quota_or_goal == "quota" ? JSON.parse(ap.cs_sales_vs_quotas) : JSON.parse(ap.cs_sales_vs_goals);
                if (rep_sales && rep_sales[scope_type] == scope_value) achievements.push(rep_sales);
            }
        })
        achievements.sort(function (a, b) {
            return (a.total_weighted_pct < b.total_weighted_pct) ? 1 : -1;
        });
        return achievements;
    }

    public getStoreAchievementsFromPreviousActionPlans(month: string, scope_type: string, scope_value: string, quota_or_goal: string): any[] {
        var achievements = [];
        var action_plans_by_month = this.action_plans_by_month[month];
        action_plans_by_month.forEach(ap => {
            //this.previous_action_plans.forEach(ap => {
            if (quota_or_goal == "quota") { }
            if (ap.ur_title == 'Store' && ap.cs_subject == month) {
                var rep_sales = quota_or_goal == "quota" ? JSON.parse(ap.cs_sales_vs_quotas) : JSON.parse(ap.cs_sales_vs_goals);
                if (rep_sales && rep_sales[scope_type] == scope_value) achievements.push(rep_sales);
            }
        })
        achievements.sort(function (a, b) {
            return (a.total_weighted_pct < b.total_weighted_pct) ? 1 : -1;
        });
        return achievements;
    }

    public getStoreSummaryAchievementFromPreviousActionPlans(month: string, scope_type: string, scope_value: string, quota_or_goal: string) {
        var achievements = this.getStoreAchievementsFromPreviousActionPlans(month, scope_type, scope_value, quota_or_goal);
        return this.getSummaryAchievementByScope(achievements, scope_type, scope_value);
    }

    public getConsultantSummaryAchievementFromPreviousActionPlans(month: string, scope_type: string, scope_value: string, quota_or_goal: string) {
        var achievements = this.getConsultantAchievementsFromPreviousActionPlans(month, scope_type, scope_value, quota_or_goal);
        return this.getSummaryAchievementByScope(achievements, scope_type, scope_value);
    }

    generateStoreSalesQuotaPlacementsFromPreviousActionPlans(scope_type: string, target_scope_value: string, scope_month: string, result_type: string = null) {
        var achievements = this.getStoreAchievementsFromPreviousActionPlans(scope_month, scope_type, target_scope_value, "quota");
        return this.generatePlacementsByScope(achievements, scope_type, target_scope_value, result_type);
    }

    generateConsultantPlacementsFromPreviousActionPlans(scope_type: string, target_scope_value: string, scope_month: string) {
        var achievements = this.getConsultantAchievementsFromPreviousActionPlans(scope_month, scope_type, target_scope_value, "quota");
        return this.generatePlacementsByScope(achievements, scope_type, target_scope_value);
    }

    getActionPlans(filters: any): Observable<any> {
        // get action plan
        var view = this.view_p2w_action_plan;
        var params: any = { p: 1, ps: 15, ob: 'cs_subject', obd: 'desc', est: 'ST_Search' }
        //var filters = [{ field: "u_user_ID", op: "=", value: null }];
        // filters.push(subject);
        params.f = JSON.stringify(filters);
        return this.apiService.getViewData(view, params);
    }

    getActionPlan(ap_ID): Observable<any> {
        return this.apiService.getViewItem(this.view_p2w_action_plan, ap_ID);
    }

    getTeamActionPlans(search_text): Observable<any> {
        // get action plan
        var params: any = { p: 1, ps: 15, est: 'ST_Search', text: search_text }
        //var filters = [{ field: "u_user_ID", op: "=", value: null }];
        // filters.push(subject);
        return this.apiService.getViewData(this.view_p2w_team_action_plan, params);
    }

    isThisMonthActionPlanSubmitted() {
        this
    }

    getThisMonthActionPlanSubject(): string {
        let date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var subject = year.toString() + (month < 10 ? '0' + month.toString() : month.toString());
        return subject;
    }

    getNextMonthActionPlanSubject(): string {
        let date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 2;
        if (month > 12) {
            month = 1;
            year = year + 1;
        }
        var subject = year.toString() + (month < 10 ? '0' + month.toString() : month.toString());
        return subject;
    }

    public getThisMonthActionPlans(user: any = null): Observable<any> {
        var filters = [{ field: "cs_subject", op: "=", value: this.getThisMonthActionPlanSubject() },]
        return this.getActionPlans(filters).map(result => {
            var action_plan = result.items.find(p => p.cs_subject == this.getThisMonthActionPlanSubject());
            if (user != null) action_plan = result.items.find(p => p.cs_subject == this.getThisMonthActionPlanSubject() && p.ur_user_ID == user.ID);
            return action_plan;
        });
    }

    public getNextMonthActionPlans() {
        var filters = [{ field: "cs_subject", op: "=", value: this.getNextMonthActionPlanSubject() },]
        return this.getActionPlans(filters).map(result => {
            var action_plan = result.items.find(p => p.cs_subject == this.getNextMonthActionPlanSubject());
            return action_plan;
        });
    }

    public is_this_month_action_plan_required: boolean;
    public has_current_month_quota_changed: boolean;
    public getHasCurrentMonthQuotaChanged(user: any = null): Observable<any> {
        return this.apiService.processActionOnViewItem(this.view_p2w_action_plan_table, 0, this.action_has_current_month_quota_changed, {}).map(result => {
            this.has_current_month_quota_changed = (result != null && result.data && result.data.quota_changed);
        })
    }

    private todaysGoalSubject = new ReplaySubject<any>(1);
    public todaysGoal = this.todaysGoalSubject.asObservable();

    todays_goal: any = null;
    getDailyGoals(override_user_ID: any = null): Observable<any> {
        // get daily goals
        var params: any = { p: 1, ps: 15, ob: 'cs_subject', obd: 'desc', est: 'ST_Search' }
        if (override_user_ID) params.override_user_ID = override_user_ID;
        var filters = [{ field: "ur_user_ID", op: "=", value: override_user_ID ? override_user_ID.toString() : null }];
        params.f = JSON.stringify(filters);
        var daily_goals = this.apiService.getViewData(this.view_p2w_daily_goal, params);
        return daily_goals;
    }

    public getTodaysGoal(bReload: boolean = false): Observable<any> {
        if (!bReload && this.todays_goal != null) {
            return new Observable(observer => {
                observer.next(this.todays_goal);
                observer.complete();
            });
        } else {
            return this.getDailyGoals().map(result => {
                var active_user = this.authService.getActive();
                this.todays_goal = result.items.find(p => p.cs_subject == this.getTodaysGoalSubject() && p.cs_user_ID == active_user.ID);
                this.setTodaysGoal(this.todays_goal);
                return this.todays_goal;
            });
        }
    }

    public setTodaysGoal(todays_goal) {
        this.todays_goal = todays_goal;
        this.todaysGoalSubject.next(todays_goal);
    }

    public createTodaysGoal(): Observable<any> {
        return this.apiService.getViewItem(this.view_p2w_daily_goal, 0).map(result => {
            var daily_goal = result.item;
            daily_goal.cs_subject = this.getTodaysGoalSubject();
            return daily_goal;
        });
    }

    public getTodaysGoalSubject(): string {
        var date = new Date();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        var subject = date.getFullYear().toString()
            + (m < 10 ? '0' + m.toString() : m.toString())
            + (d < 10 ? '0' + d.toString() : d.toString());
        return subject;
    }

    public corp_descriptions = {
        postpaid_basic: "Postpaid Handsets Sold with Basic Plan",
        postpaid_everyday: "Postpaid Handsets Sold with Every Day Plan",
        postpaid_even_better: "Postpaid Handsets Sold with Even Better Plan",
        postpaid_handset_volume: "Postpaid Smart and Feature Phones.  Note: The minimum threshold for Postpaid Handset sales vs quota is 50%.",
        total_postpaid: "Postpaid Smart and Feature Phones.  Note: The minimum threshold for Postpaid Handset sales vs quota is 50%.",
        hsi: "Note:  there is no minimum threshold for HSI sales vs quota.",
        prepaid: "Note: The minimum threshold for Prepaid Handset sales vs quota is 35%.",
        connected_devices: "Note: The minimum threshold for Other Connected Devices sales vs quota is 35%.",
        other_volume: "Prepaid Handsets plus Postpaid Home Phones, Routers, Tablets, IoT/M2M, Other Connected Devices.  Note: Over Performance Incentive is $25 per activation.",
        accessories_revenue: "Note: Over Performance Incentive (which will be calculated once the Total Revenue target has been achieved) is 20% of Actual Sale Price.",
        other_revenue: "DP+ Revenue Credit and Other Revenue. Note: Over Performance Incentive (which will be calculated once the Total Revenue target has been achieved) is 20% of Actual Sale Price.",
        bir: "BiR",
        upgrades_basic: "Upgrades Sold with Basic Plan",
        upgrades_everyday: "Upgrades Sold with Everyday Plan",
        upgrades_even_better: "Upgrades Sold with Even Better Plan",
        upgrades: "Note: The minimum threshold for Upgrade contributions vs quota is 60%.",
        total_upgrades: "Note: The minimum threshold for Upgrade contributions vs quota is 60%.",
        high_msrp_accessories: "Note: Over Performance Incentive is $7.50 per activation.",
        device_trade_ins: "Device Trade Ins",
        revenue: "DP+ Revenue Credit and Other Revenue. Note: This minimum threshold for Revenue sales vs quota is 60%. Over Performance Incentive is 10% of Actual Sale Price.",
        total_gross_adds: "Note: The minimum threshold for Total Gross Adds contributions vs quota is 60%.",
        oei: "Note: the minimum threshold for OEI index is 51%. 51 to 59.99% = 60% target payout. 60 to 69.99% = 70% target payout. 70 to 79.99% = 80% target payout. 80 to 89.99% = 90% target payout. 90 to 94.99% = 100% target payout.  95 to 97.99% = 120% target payout.  Over 98% = 130% target payout.",
        spiff: "Spiff"
    }

    public telesales_descriptions = {
        postpaid_basic: "Postpaid Handsets Sold with Basic Plan",
        postpaid_everyday: "Postpaid Handsets Sold with Every Day Plan",
        postpaid_even_better: "Postpaid Handsets Sold with Even Better Plan",
        postpaid_handset_volume: "Postpaid Smart & Feature Phones.  Note: Over Performance Incentive is $75 per activation.",
        total_postpaid: "Postpaid Smart and Feature Phones.  Note: The minimum threshold for Postpaid Handset sales vs quota is 50%.",
        hsi: "Note:  there is no minimum threshold for HSI sales vs quota.",
        prepaid: "Note: The minimum threshold for Prepaid Handset sales vs quota is 35%.",
        connected_devices: "Note: The minimum threshold for Other Connected Devices sales vs quota is 35%.",
        total_gross_adds: "Note: The minimum threshold for Total Gross Adds contributions vs quota is 60%.",
        other_volume: "Prepaid Handsets plus Postpaid Home Phones, Routers, Tablets, IoT/M2M, Other Connected Devices.  Note: Over Performance Incentive is $25 per activation.",
        accessories_revenue: "Note: Over Performance Incentive (which will be calculated once the Total Revenue target has been achieved) is 10% of Actual Sale Price.",
        other_revenue: "DP+ Revenue Credit and Other Revenue. Note: Over Performance Incentive (which will be calculated once the Total Revenue target has been achieved) is 10% of Actual Sale Price.",
        bir: "BiR",
        upgrades_basic: "Upgrades Sold with Basic Plan",
        upgrades_everyday: "Upgrades Sold with Everyday Plan",
        upgrades_even_better: "Upgrades Sold with Even Better Plan",
        total_upgrades: "Note: The minimum threshold for Upgrade contributions vs quota is 60%.",
        upgrades: "Note: Over Performance Incentive is $5.00 per activation.",
        high_msrp_accessories: "Note: Over Performance Incentive is $10.00 per activation.",
        device_trade_ins: "Device Trade Ins",
        revenue: this.isLeader() ? "DP+ Revenue Credit and Other Revenue.  Note: The minimum threshold for Revenue sales vs quota is 60%.  Over Performance Incentive is calculated based on % of sales in excess of quota." : "DP+ Revenue Credit and Other Revenue.  Note: The minimum threshold for Revenue sales vs quota is 60%.  Over Performance Incentive is 10% of Actual Sale Price.",
        spiff: "Spiff",
        cei: "Note: The minimum threshold for CEI Index is 57.01%"
    }

    getBusinessDriverDesc(field) {
        var descriptions = {};
        if (this.isUSCellCorp()) descriptions = this.corp_descriptions;
        if (this.isUSCellTelesales()) descriptions = this.telesales_descriptions;
        return descriptions[field];
    }

    getBusinessDriver(type: string) {
        if (type.indexOf('postpaid_basic') >= 0) return 'Postpaid - Basic';
        if (type.indexOf('postpaid_everyday') >= 0) return 'Postpaid - Everyday';
        if (type.indexOf('postpaid_even_better') >= 0) return 'Postpaid - Even Better';
        if (type.indexOf('postpaid_handset_volume') >= 0) return 'Postpaid';
        if (type.indexOf('hsi') >= 0) return 'HSI';
        if (type.indexOf('prepaid') >= 0) return 'Prepaid';
        if (type.indexOf('connected_devices') >= 0) return 'Other Connected Devices';
        if (type.indexOf('other_volume') >= 0) return 'Other Volume';
        if (type.indexOf('accessories_revenue') >= 0) return 'Accessories Revenue';
        if (type.indexOf('accessory_revenue') >= 0) return 'Accessories Revenue';
        if (type.indexOf('other_revenue') >= 0) return 'Other Revenue';
        if (type == 'revenue') return 'Revenue';
        if (type.indexOf('bir') >= 0) return 'BiR';
        if (type.indexOf('upgrades_basic') >= 0) return 'Upgrades - Basic';
        if (type.indexOf('upgrades_everyday') >= 0) return 'Upgrades - Everyday';
        if (type.indexOf('upgrades_even_better') >= 0) return 'Upgrades - Even Better';
        if (type.indexOf('upgrades') >= 0) return 'Upgrades';
        if (type.indexOf('high_msrp_accessories') >= 0) return 'High MSRP Accessories';
        if (type.indexOf('device_trade_ins') >= 0) return 'Device Trade Ins';
    }

    getFillBgColor(mtd_pct): string {
        var lgreen = "#dcf0c6";
        var lred = "#ffbfd9";
        var lorange = "#eeca87";
        var lgray = '#e4e4e4';

        if (mtd_pct > 0.666666) return lgreen;
        else if (mtd_pct > 0.333333) return lorange;
        else if (mtd_pct > 0) return lred;
        else return lgray;
    }

    getFillColor(mtd_pct): string {
        var green = "#57b600";
        var red = "#fe005e";
        var orange = "#f7a700";

        if (mtd_pct > 0.666666) return green;
        else if (mtd_pct > 0.333333) return orange;
        else if (mtd_pct > 0) return red;
    }
    // #endregion action plans and daily goals - end

    // #region payout estimator - begin
    getThisMonthPayoutEstimate(drivers, action_plan, days_remaining, testing: any = null): Observable<any> {
        return this.apiService.getViewItem(this.view_p2w_payout_estimator, action_plan.view_ID).map(result => {
            var payout_estimate = result.item;
            if (testing) {
                testing.postpaid = { mtd: payout_estimate.mtd_postpaid_handset_volume };
                testing.other_volume = { mtd: payout_estimate.mtd_other_volume };
                testing.revenue = { mtd: payout_estimate.mtd_accessories_revenue + payout_estimate.mtd_other_revenue };
                testing.upgrades = { mtd: payout_estimate.mtd_upgrades };
                testing.high_msrp_accessories = { mtd: payout_estimate.mtd_high_msrp_accessories };
            }
            return this.calculateEstimatedPayout(drivers, action_plan, payout_estimate, days_remaining, false, testing);
        })
    }

    calculateEstimatedPayout(drivers: any, action_plan: any, payout_estimate: any, days_remaining: number, use_goal_as_mtd: boolean = false, testing: any = null): any {
        var target_incentives = JSON.parse(payout_estimate.target_incentives);
        var kicker_values = JSON.parse(payout_estimate.kicker_values);

        drivers.forEach(d => {
            switch (d.driver) {
                case "postpaid":
                    d.mtd = payout_estimate.mtd_postpaid_handset_volume;
                    d.quota = JSON.parse(payout_estimate.ur_quota_postpaid_handset)[action_plan.cs_subject];
                    if (use_goal_as_mtd) d.mtd = action_plan.cs_p2w_postpaid;
                    break;
                case "other_volume":
                    d.mtd = payout_estimate.mtd_other_volume;
                    d.quota = JSON.parse(payout_estimate.ur_quota_other_volume)[action_plan.cs_subject];
                    if (use_goal_as_mtd) d.mtd = action_plan.cs_p2w_other;
                    break;
                case "revenue":
                    d.mtd = payout_estimate.mtd_accessories_revenue + payout_estimate.mtd_other_revenue;
                    var quota_accessory = (payout_estimate.ur_quota_accessories_revenue) ? JSON.parse(payout_estimate.ur_quota_accessories_revenue)[action_plan.cs_subject] : 0;
                    var quota_other_revenue = (payout_estimate.ur_quota_other_revenue) ? JSON.parse(payout_estimate.ur_quota_other_revenue)[action_plan.cs_subject] : 0;
                    //var quota_other_revenue = JSON.parse(payout_estimate.ur_quota_other_revenue)[action_plan.cs_subject];
                    d.quota = quota_accessory + quota_other_revenue;
                    if (use_goal_as_mtd) d.mtd = action_plan.cs_p2w_other_revenue + action_plan.cs_p2w_accessories_revenue;
                    break;
                case "upgrades":
                    d.mtd = payout_estimate.mtd_upgrades;
                    if (use_goal_as_mtd) d.mtd = action_plan.cs_p2w_upgrades;
                    break;
                case "high_msrp_accessories":
                    d.mtd = payout_estimate.mtd_high_msrp_accessories;
                    if (use_goal_as_mtd) d.mtd = action_plan.cs_p2w_high_acc;
                    break;
            }

            if (testing) {
                d.mtd = parseInt(testing[d.driver].mtd);
            }

            // average sales over days scheduled
            d.avg = d.quota / action_plan.cs_days_scheduled;
            // pacing average sales over days remaining
            if (d.quota - d.mtd > 0 && days_remaining > 0) d.pacing_avg = (d.quota - d.mtd) / days_remaining;
            d.mtd_quota_pct = d.quota > 0 ? d.mtd / d.quota : 0;
            // calculate incentive earned
            var incentive = this.getTargetIncentive(action_plan, target_incentives, d.driver);
            if (incentive) {
                d.incentive = incentive.value;
                d.incentive_pct = d.mtd_quota_pct;
                if (incentive.min_pct > 0 && d.mtd_quota_pct < incentive.min_pct) d.incentive_pct = 0;
                if (incentive.max_pct > 0 && d.mtd_quota_pct >= incentive.max_pct) d.incentive_pct = incentive.max_pct;
                d.incentive_earned = d.incentive * d.incentive_pct;

                if (incentive.min_pct > 0 && d.forcecast_quota_pct < incentive.min_pct) d.forcecast_quota_pct = 0;
                if (incentive.max_pct > 0 && d.forcecast_quota_pct >= incentive.max_pct) d.forcecast_quota_pct = incentive.max_pct;
            }
            // calculate kicker earned (seems like the math is exactly the same for both kicker_types, but keeping it separate for flexiblility)
            var kicker_value = this.getKickerValue(action_plan, kicker_values, d.driver);
            var excess_value = d.mtd - d.quota;
            if (kicker_value) {
                d.kicker_value = kicker_value.kicker_type == "pct_of_excess" ? kicker_value.pct_value : kicker_value.value;
                d.kicker_earned = 0;
                if (excess_value > 0) {
                    if (kicker_value.kicker_type == "value_per_unit") {
                        d.kicker_earned = excess_value * kicker_value.value;
                    } else if (kicker_value.kicker_type == "pct_of_excess") {
                        d.kicker_earned = excess_value * kicker_value.pct_value;
                    }
                }
            }
            d.payout = Math.ceil((d.incentive_earned + d.kicker_earned) * 100) / 100;

            // forecast figures at end of month for pacing payout
            // d.forecast = d.mtd + (d.avg * days_remaining);
            d.forecast_avg = action_plan.days_worked > 0 ? d.mtd / action_plan.days_worked : 0;
            d.forecast = d.mtd + (d.forecast_avg * days_remaining);
            if (d.mtd > d.quota) d.forecast_avg = d.avg;
            d.forcecast_quota_pct = d.quota > 0 ? d.forecast / d.quota : 0;
            if (incentive) d.forecast_incentive_earned = d.incentive * d.forcecast_quota_pct;
            var forecast_excess_value = d.forecast - d.quota;  // floor or ceiling?
            if (kicker_value) {
                d.forecast_kicker_earned = 0;
                if (forecast_excess_value > 0) {
                    if (kicker_value.kicker_type == "value_per_unit") {
                        d.forecast_kicker_earned = forecast_excess_value * kicker_value.value;
                    } else if (kicker_value.kicker_type == "pct_of_excess") {
                        d.forecast_kicker_earned = forecast_excess_value * kicker_value.pct_value;
                    }
                }
            }
            // round to the cent
            d.forecast_payout = Math.ceil((d.forecast_incentive_earned + d.forecast_kicker_earned) * 100) / 100;

            if (testing) {
                testing[d.driver].avg = d.avg;
                testing[d.driver].forecast_avg = d.forecast_avg;
                testing[d.driver].forecast = d.forecast;
                testing[d.driver].mtd_quota_pct = d.mtd_quota_pct;
                testing[d.driver].forcecast_quota_pct = d.forcecast_quota_pct;
                testing[d.driver].excess_value = excess_value;
                testing[d.driver].forecast_excess_value = d.forecast_incentive_earned;
                testing[d.driver].forecast_excess_value = forecast_excess_value;
                testing[d.driver].forecast_kicker_earned = d.forecast_kicker_earned;
                testing[d.driver].forecast_payout = d.forecast_payout;
            }
        })
        // calculate mtd total
        var total_estimated_payout = 0;
        var total_pacing_payout = 0;
        drivers.forEach(d => {
            total_estimated_payout = total_estimated_payout + d.payout;
            total_pacing_payout = total_pacing_payout + d.forecast_payout;
        })
        // return results
        var mtd_totals = {
            drivers: drivers,
            payout_estimate: payout_estimate,
            total_estimated_payout: total_estimated_payout,
            total_pacing_payout: total_pacing_payout,
            target_incentives: target_incentives,
            kicker_values: kicker_values
        }
        return mtd_totals;
    }

    getTargetIncentive(action_plan, target_incentives, driver) {
        var incentive = target_incentives[driver].find(i => i.title == action_plan.ur_title);
        return incentive;
    }

    getKickerValue(action_plan, kicker_values, driver) {
        var kicker = kicker_values[driver].find(i => i.title == action_plan.ur_title);
        return kicker;
    }
    // #endregion payout estimator - end

    // #region achievement helper
    getUniquePropertyFromArray(array: any[], prop: string) {
        var scope_values = [];
        array.forEach(a => {
            var scope_value = a[prop];
            if (scope_values.indexOf(scope_value) < 0) {
                scope_values.push(scope_value);
            }
        })
        return scope_values;
    }

    public title_to_achievement_scope_type_mapping = [
        // corporate mapping
        { title: "VP - Retail Sales and Operations", scope_type: "channel" },
        { title: "Area VP-General Mgr, Retail Sales & Ops", scope_type: "region" },
        { title: "Dir Retail Sales and Operations", scope_type: "territory" },
        { title: "Mgr Retail Area Sales", scope_type: "area" },
        { title: "Store Mgr I", scope_type: "store" },
        { title: "Store Mgr II", scope_type: "store" },
        { title: "Mgr Store", scope_type: "store" },
        { title: "Mgr Sales", scope_type: "store" },
        { title: "Assistant Manager", scope_type: "store" },
        // telesales mapping
        { title: "VP - Customer Support", scope_type: "channel" },
        { title: "Mgr Telesales", scope_type: "store" },
        { title: "Telesales Supervisor", scope_type: "store" },
        // agent mapping
        { title: "Master", scope_type: "agency" },
        { title: "Admin/Manager of Agency", scope_type: "agency" },
        { title: "Area Manager", scope_type: "store" },
        { title: "Manager", scope_type: "store" },
    ];

    public getDefaultAchievementScopeTeam(scope_user) {
        var scope: any = {};
        // associate/consultant
        if (!this.isLeader() && scope_user) {
            scope.scope_type = 'ur_username';
            scope.scope_value = scope_user.username;
        } else {
            var store_ID = this.getAssociateStoreID(scope_user);
            // var store_ID = this.getItemCustomFieldValue(scope_user, "TopsID");
            var scope_mapping = this.title_to_achievement_scope_type_mapping.find(m => m.title == scope_user.title);
            if (scope_mapping == null) {
                scope_user = this.getUserSupervisor(scope_user);
            }
            // HACK: it is possible that the current team leader (AVP/DOS/MRAS) are placeholder user accounts
            //       therefore, the lastname of the account would be the position number, which is used to generate the dataset (sales vs quota/goal)
            scope.scope_value = this.conditionService.isNumeric(scope_user.last_name) ? scope_user.last_name : scope_user.first_name + ' ' + scope_user.last_name;
            // double check the scope_user title again         
            scope_mapping = this.title_to_achievement_scope_type_mapping.find(m => m.title == scope_user.title);
            if (scope_mapping) scope.scope_type = scope_mapping.scope_type;
            // telesales supervisors have channel scope
            //if (scope.scope_type == "channel" && this.isUSCellTelesales()) scope.scope_value = "Telesales";
            if (scope.scope_type == "agency") scope.scope_value = this.getAgencyNameByUser(scope_user);
            if (scope.scope_type == "store" && store_ID) {
                // if failed again, the this user must be in the scope_type = store            
                scope.scope_value = this.getStoreNameByStoreID(store_ID);
                scope.scope_type = "store";
            }
        }

        return scope;
    }

    // result_type: group by scope
    private getAchievementsByScope(achievements: any[], scope_type: string, scope_value: string, result_type: string = null) {
        var scope_achievements = [];
        achievements.forEach(a => {
            var result_achievement = JSON.parse(JSON.stringify(a));
            if (result_achievement[scope_type] == scope_value) {
                if (result_type) {
                    var result_type_value = result_achievement[result_type];
                    var rt = scope_achievements.find(a => a[result_type] == result_type_value);
                    if (rt) {
                        rt.total_weighted_pct += result_achievement.total_weighted_pct;
                        rt.instance_count++;
                        result_achievement = null;
                    }
                }
                if (result_achievement) {
                    result_achievement.instance_count = 1;
                    scope_achievements.push(result_achievement);
                }
            }
        })

        if (result_type && result_type != 'store') {
            // recalculate the avg total_weighted_pct
            scope_achievements.forEach(a => {
                a.total_weighted_pct = a.total_weighted_pct / a.instance_count;
            });

            // sort by total_weighted_pct descending
            scope_achievements.sort(function (a, b) {
                return (a.total_weighted_pct < b.total_weighted_pct) ? 1 : -1;
            })
        }
        return scope_achievements;
    }

    private generatePlacementsByScope(achievements: any[], scope_type: string, target_scope_value: string, result_type: string = null) {
        var placements = [];
        var scope_achievements = this.getAchievementsByScope(achievements, scope_type, target_scope_value, result_type);
        scope_achievements.forEach(a => {
            var prev_placement = (placements.length > 0) ? placements[placements.length - 1] : null;
            var ranking = (prev_placement && a.total_weighted_pct == prev_placement.achievement.total_weighted_pct) ? prev_placement.ranking : placements.length + 1;
            placements.push({ achievement: a, ranking: ranking });
        })
        return placements;
    }

    getAchievementScopeTeams(achievements: any[], prev_scope_type: string, prev_scope_value: string, next_scope_type: string) {
        var scope_teams = [];
        var next_scope_values = [];
        achievements.forEach(a => {
            if (a[prev_scope_type] == prev_scope_value) {
                if (next_scope_values.indexOf(a[next_scope_type]) < 0) {
                    next_scope_values.push(a[next_scope_type]);
                }
            }
        });
        next_scope_values.forEach(s => {
            scope_teams.push({ scope_type: next_scope_type, scope_value: s });
        });
        return scope_teams;
    }

    getSummaryAchievementByScope(achievements: any[], scope_type: string, scope_value: string) {
        var summary_achievement = null;
        achievements.forEach(a => {
            if (a[scope_type] == scope_value) {
                if (summary_achievement == null) {
                    // copy first achievement entry as summary_achievement
                    summary_achievement = JSON.parse(JSON.stringify(a));
                    // initialize null quota as 0
                    if (summary_achievement.quota_postpaid_handset_volume == null) summary_achievement.quota_postpaid_handset_volume = 0;
                    if (summary_achievement.quota_prepaid == null) summary_achievement.quota_prepaid = 0;
                    if (summary_achievement.quota_hsi == null) summary_achievement.quota_hsi = 0;
                    if (summary_achievement.quota_connected_devices == null) summary_achievement.quota_connected_devices = 0;
                    if (summary_achievement.quota_other_volume == null) summary_achievement.quota_other_volume = 0;
                    if (summary_achievement.quota_revenue == null) summary_achievement.quota_revenue = 0;
                    if (summary_achievement.quota_accessory_revenue == null) summary_achievement.quota_accessory_revenue = 0;
                    if (summary_achievement.quota_other_revenue == null) summary_achievement.quota_other_revenue = 0;
                    if (summary_achievement.quota_bir == null) summary_achievement.quota_bir = 0;
                    if (summary_achievement.quota_upgrades == null) summary_achievement.quota_upgrades = 0;
                    if (summary_achievement.quota_high_msrp_accessories == null) summary_achievement.quota_high_msrp_accessories = 0;
                    if (summary_achievement.quota_device_trade_ins == null) summary_achievement.quota_device_trade_ins = 0;
                    // initialize null goal as 0
                    if (summary_achievement.goal_postpaid_handset_volume == null) summary_achievement.goal_postpaid_handset_volume = 0;
                    if (summary_achievement.goal_prepaid == null) summary_achievement.goal_prepaid = 0;
                    if (summary_achievement.goal_hsi == null) summary_achievement.goal_hsi = 0;
                    if (summary_achievement.goal_connected_devices == null) summary_achievement.goal_connected_devices = 0;
                    if (summary_achievement.goal_other_volume == null) summary_achievement.goal_other_volume = 0;
                    if (summary_achievement.goal_revenue == null) summary_achievement.goal_revenue = 0;
                    if (summary_achievement.goal_accessory_revenue == null) summary_achievement.goal_accessory_revenue = 0;
                    if (summary_achievement.goal_other_revenue == null) summary_achievement.goal_other_revenue = 0;
                    if (summary_achievement.goal_bir == null) summary_achievement.goal_bir = 0;
                    if (summary_achievement.goal_upgrades == null) summary_achievement.goal_upgrades = 0;
                    if (summary_achievement.goal_high_msrp_accessories == null) summary_achievement.goal_high_msrp_accessories = 0;
                    if (summary_achievement.goal_device_trade_ins == null) summary_achievement.goal_device_trade_ins = 0;
                } else {
                    // subsequent achievement entries are sum'ed into summary_achievement
                    summary_achievement.postpaid_handset_volume += a.postpaid_handset_volume;
                    summary_achievement.prepaid += a.prepaid;
                    summary_achievement.hsi += a.hsi;
                    summary_achievement.connected_devices += a.connected_devices;
                    summary_achievement.other_volume += a.other_volume;
                    summary_achievement.revenue += a.revenue;
                    summary_achievement.accessory_revenue += a.accessory_revenue;
                    summary_achievement.accessories_revenue += a.accessories_revenue;
                    summary_achievement.other_revenue += a.other_revenue;
                    summary_achievement.bir += a.bir;
                    summary_achievement.upgrades += a.upgrades;
                    summary_achievement.high_msrp_accessories += a.high_msrp_accessories;
                    summary_achievement.device_trade_ins += a.device_trade_ins;
                    // sum up all quota for the scope_type
                    if (a.quota_postpaid_handset_volume) summary_achievement.quota_postpaid_handset_volume += a.quota_postpaid_handset_volume;
                    if (a.quota_prepaid) summary_achievement.quota_prepaid += a.quota_prepaid;
                    if (a.quota_hsi) summary_achievement.quota_hsi += a.quota_hsi;
                    if (a.quota_connected_devices) summary_achievement.quota_connected_devices += a.quota_connected_devices;
                    if (a.quota_other_volume) summary_achievement.quota_other_volume += a.quota_other_volume;
                    if (a.quota_revenue) summary_achievement.quota_revenue += a.quota_revenue;
                    if (a.quota_other_revenue) summary_achievement.quota_other_revenue += a.quota_other_revenue;
                    if (a.quota_accessory_revenue) summary_achievement.quota_accessory_revenue += a.quota_accessory_revenue;
                    if (a.quota_accessories_revenue) summary_achievement.quota_accessories_revenue += a.quota_accessories_revenue;
                    if (a.quota_bir) summary_achievement.quota_bir += a.quota_bir;
                    if (a.quota_upgrades) summary_achievement.quota_upgrades += a.quota_upgrades;
                    if (a.quota_high_msrp_accessories) summary_achievement.quota_high_msrp_accessories += a.quota_high_msrp_accessories;
                    if (a.quota_device_trade_ins) summary_achievement.quota_device_trade_ins += a.quota_device_trade_ins;
                    // sum up all goal for the scope_type
                    if (a.goal_postpaid_handset_volume) summary_achievement.goal_postpaid_handset_volume += a.goal_postpaid_handset_volume;
                    if (a.goal_prepaid) summary_achievement.goal_prepaid += a.goal_prepaid;
                    if (a.goal_hsi) summary_achievement.goal_hsi += a.goal_hsi;
                    if (a.goal_connected_devices) summary_achievement.goal_connected_devices += a.goal_connected_devices;
                    if (a.goal_other_volume) summary_achievement.goal_other_volume += a.goal_other_volume;
                    if (a.goal_revenue) summary_achievement.goal_revenue += a.goal_revenue;
                    if (a.goal_other_revenue) summary_achievement.goal_other_revenue += a.goal_other_revenue;
                    if (a.goal_accessory_revenue) summary_achievement.goal_accessory_revenue += a.goal_accessory_revenue;
                    if (a.goal_accessories_revenue) summary_achievement.goal_accessories_revenue += a.goal_accessories_revenue;
                    if (a.goal_bir) summary_achievement.goal_bir += a.goal_bir;
                    if (a.goal_upgrades) summary_achievement.goal_upgrades += a.goal_upgrades;
                    if (a.goal_high_msrp_accessories) summary_achievement.goal_high_msrp_accessories += a.goal_high_msrp_accessories;
                    if (a.goal_device_trade_ins) summary_achievement.goal_device_trade_ins += a.goal_device_trade_ins;
                }
            }
        });
        return summary_achievement;
    }

    private p2wSalesTrackerTestingSubject = new ReplaySubject<any>(1);
    public p2wSalesTrackerTesting = this.p2wSalesTrackerTestingSubject.asObservable();

    setP2wSalesTrackerTesting(testing) {
        this.p2wSalesTrackerTestingSubject.next(testing);
    }
    // #endregion

    // #region sales quota achievements 
    public consultant_sales_quota_achievements: any = null;
    getConsultantSalesQuotaAchievements(bReload: boolean = false): Observable<any> {
        // get action plan
        if (this.consultant_sales_quota_achievements == null || bReload) {
            return this.apiService.getViewData(this.view_p2w_sales_quota_achievements, { est: 'ST_Search' }).map(result => {
                this.consultant_sales_quota_achievements = result.items;
                return this.consultant_sales_quota_achievements;
            })
        } else {
            return this.consultant_sales_quota_achievements;
        }
    }

    getConsultantAchievementByUser(user) {
        return this.consultant_sales_quota_achievements.find(a => a.CREATOR_ID == user.username);
    }

    getConsultantAchievementsByScopeType(scope_type, scope_value) {
        return this.getAchievementsByScope(this.consultant_sales_quota_achievements, scope_type, scope_value);
    }

    generateConsultantPlacementsByScope(scope_type: string, target_scope_value: string) {
        return this.generatePlacementsByScope(this.consultant_sales_quota_achievements, scope_type, target_scope_value);
    }

    generateTodaysConsultantPlacementsByScope(scope_type: string, target_scope_value: string) {
        // 2023-04-09 HACK: since we don't have daily achievements by quota, just use daily achievements by goal (should be the same) 
        return this.generatePlacementsByScope(this.consultant_todays_sales_goal_achievements, scope_type, target_scope_value);
    }
    // #region

    // sales goal achievements - begin
    public consultant_sales_goal_achievements: any = null;
    getConsultantSalesGoalAchievements(bReload: boolean = false): Observable<any> {
        if (this.consultant_sales_goal_achievements == null || bReload) {
            return this.apiService.getViewData(this.view_p2w_sales_goal_achievements, { est: 'ST_Search' }).map(result => {
                this.consultant_sales_goal_achievements = result.items;
                return this.consultant_sales_goal_achievements;
            })
        } else {
            return this.consultant_sales_goal_achievements;
        }
    }

    getConsultantSalesGoalAchievementByScope(scope_type: string, scope_value: string) {
        return this.getAchievementsByScope(this.consultant_sales_goal_achievements, scope_type, scope_value);
    }

    getStoreSalesGoalAchievementByScope(scope_type: string, scope_value: string) {
        return this.getSummaryAchievementByScope(this.consultant_sales_goal_achievements, scope_type, scope_value);
    }

    public consultant_todays_sales_goal_achievements: any = null;
    getTodaysConsultantSalesGoalAchievements(bReload: boolean = false): Observable<any> {
        if (this.consultant_todays_sales_goal_achievements == null || bReload) {
            return this.apiService.getViewData(this.view_p2w_todays_sales_goal_achievements, { est: 'ST_Search' }).map(result => {
                this.consultant_todays_sales_goal_achievements = result.items;
                return this.consultant_todays_sales_goal_achievements;
            })
        } else {
            return this.consultant_sales_goal_achievements;
        }
    }

    getTodaysStoreSalesGoalAchievementByScope(scope_type: string, scope_value: string) {
        return this.getSummaryAchievementByScope(this.consultant_todays_sales_goal_achievements, scope_type, scope_value);
    }
    // sales goal achievements - end

    // #region today's store sales quota achievements 
    public store_todays_sales_quota_achievements: any = null;
    getStoreTodaysSalesQuotaAchievements(bReload: boolean = false): Observable<any> {
        // get action plan
        if (this.store_todays_sales_quota_achievements == null || bReload) {
            var view = this.view_p2w_store_todays_sales_quota_achievements;
            var params: any = { est: 'ST_Search' }
            return this.apiService.getViewData(view, params).map(result => {
                this.store_todays_sales_quota_achievements = result.items;
                return this.store_todays_sales_quota_achievements;
            })
        } else {
            return this.store_todays_sales_quota_achievements;
        }
    }

    getTodaysStoreSalesQuotaAchievementByScope(scope_type: string, scope_value: string) {
        return this.getSummaryAchievementByScope(this.store_todays_sales_quota_achievements, scope_type, scope_value);
    }

    getTodaysStoreAchievementsByScopeType(scope_type: string, scope_value: string) {
        return this.getAchievementsByScope(this.store_todays_sales_quota_achievements, scope_type, scope_value);
    }
    // #endregion

    // #region store sales quota achievements - begin
    public store_sales_quota_achievements: any = null;
    getStoreSalesQuotaAchievements(bReload: boolean = false): Observable<any> {
        // get action plan
        if (this.store_sales_quota_achievements == null || bReload) {
            var view = this.view_p2w_store_sales_quota_achievements;
            var params: any = { est: 'ST_Search' }
            return this.apiService.getViewData(view, params).map(result => {
                this.store_sales_quota_achievements = result.items;
                return this.store_sales_quota_achievements;
            })
        } else {
            return this.store_sales_quota_achievements;
        }
    }

    getStoreNameByStoreID(store_ID) {
        var achievement = this.store_sales_quota_achievements.find(a => a.store_ID == store_ID);
        return achievement ? achievement.store : "";
    }

    getStoreSalesQuotaAchievementsByScopeType(scope_type: string, scope_value: string) {
        return this.getAchievementsByScope(this.store_sales_quota_achievements, scope_type, scope_value);
    }

    // placements by sales quota
    generateStoreSalesQuotaPlacementsByScope(scope_type: string, target_scope_value: string, result_type: string = null) {
        return this.generatePlacementsByScope(this.store_sales_quota_achievements, scope_type, target_scope_value, result_type);
    }

    generateTodaysStoreSalesQuotaPlacementsByScope(scope_type: string, target_scope_value: string, result_type: string = null) {
        return this.generatePlacementsByScope(this.store_todays_sales_quota_achievements, scope_type, target_scope_value, result_type);
    }

    // summary archievements
    getStoreSalesQuotaSummaryAchievementByScope(scope_type: string, scope_value: string) {
        return this.getSummaryAchievementByScope(this.store_sales_quota_achievements, scope_type, scope_value);
    }

    getStoreSalesQuotaAchievementScopeTeams(prev_scope_type: string, prev_scope_value: string, next_scope_type: string) {
        return this.getAchievementScopeTeams(this.store_sales_quota_achievements, prev_scope_type, prev_scope_value, next_scope_type);
    }
    // #endregion  store sales quota achievements - end

    private p2wTeamSalesTrackerScopeSubject = new ReplaySubject<any>(1);
    public p2wTeamSalesTrackerScope = this.p2wTeamSalesTrackerScopeSubject.asObservable();
    private p2wTeamSalesTrackerScopeHistory: any[] = [];

    resetTeamSalesTrackerScopeHistory() {
        this.p2wTeamSalesTrackerScopeHistory = [];
    }

    setP2wTeamSalesTrackerScope(scope, bAddToHistory: boolean = true) {
        this.p2wTeamSalesTrackerScopeSubject.next(scope);
        // reset other_results on team scope changes
        this.p2w_other_results = null;
        this.p2w_todays_other_results = null;
        if (bAddToHistory) this.p2wTeamSalesTrackerScopeHistory.push(scope);
    }

    gotoPreviousP2wTeamSalesTrackerScope() {
        var scope = null;
        this.p2wTeamSalesTrackerScopeHistory.pop();
        if (this.p2wTeamSalesTrackerScopeHistory.length > 0) {
            scope = this.p2wTeamSalesTrackerScopeHistory[this.p2wTeamSalesTrackerScopeHistory.length - 1];
        }
        this.setP2wTeamSalesTrackerScope(scope, false);
    }

    private p2wTeamSalesTrackerUserSubject = new ReplaySubject<any>(1);
    public p2wTeamSalesTrackerUser = this.p2wTeamSalesTrackerUserSubject.asObservable();
    setP2wTeamSalesTrackerUser(user) {
        this.p2wTeamSalesTrackerUserSubject.next(user);
    }

    public p2wDetailResultScope = null;
    public setCurrentDetailResultScope(scope) {
        this.p2wDetailResultScope = scope;
    }

    public getCurrentDetailResultScope() {
        return this.p2wDetailResultScope;
    }

    // #region portal / p2w initialization 
    private portalReadySubject = new ReplaySubject<any>(1);
    public portalReady = this.portalReadySubject.asObservable();

    public portal_initializations: any[] = [];
    //status = {'initializing', 'initialized', 'failed'}
    public setPortalInitializationItem(type: string, status: string) {
        this.portalReadySubject.next(false);
        var pi = this.portal_initializations.find(i => i.type == type);
        if (pi == null) {
            this.portal_initializations.push({ type: type, status: status });
        } else {
            pi.status = status;
        }
        this.sessionService.log("setPortalInitializationItem", { type: type, status: status });
        this.sessionService.log("isPortalInitialized", this.isPortalInitialized());
        if (this.isPortalInitialized()) {
            this.portalReadySubject.next(true);
            //this.reloadP2WAchievementsSubject.next(false);
        }
    }

    public isPortalInitialized(): boolean {
        return this.portal_initializations.find(i => i.status != 'initialized') == null;
    }

    private p2wReadySubject = new ReplaySubject<any>(1);
    public p2wReady = this.p2wReadySubject.asObservable();

    public p2w_initializations: any[] = [];
    public setP2WInitializationItem(type: string, status: string) {
        this.p2wReadySubject.next(false);
        var pi = this.p2w_initializations.find(i => i.type == type);
        if (pi == null) {
            this.p2w_initializations.push({ type: type, status: status });
        } else {
            pi.status = status;
        }
        if (this.isP2WInitialized()) {
            this.p2wReadySubject.next(true);
            this.reloadP2WAchievementsSubject.next(false);
        }
    }

    public isP2WInitialized(): boolean {
        if (this.p2w_initializations.length == 0) return false;
        return this.p2w_initializations.find(i => i.status != 'initialized') == null;
    }

    // Reload P2W Data 
    private reloadP2WAchievementsSubject = new ReplaySubject<boolean>(1);
    public reloadP2WAchievements = this.reloadP2WAchievementsSubject.asObservable();

    public triggerReloadP2WAchievements() {
        this.p2wReadySubject.next(false);
        this.reloadP2WAchievementsSubject.next(true);
    }
    // #endregion

    private gotoActionPlanSubject = new ReplaySubject<any>(1);
    public gotoActionPlan = this.gotoActionPlanSubject.asObservable();
    setActionPlan(ap) {
        this.gotoActionPlanSubject.next(ap);
    }

    private p2wScopeMonthSubject = new BehaviorSubject<any>(1);
    public p2wScopeMonth = this.p2wScopeMonthSubject.asObservable();
    setP2WScopeMonth(month) {
        this.p2wScopeMonthSubject.next(month);
    }

    getEstimatePayoutDesc() {
        return "Please note that these are estimates only and do not represent final or actual month end payout. Please reference ORCA for actual commission statements..";
    }

    getWeightedScoreDesc() {
        if (this.isUSCellAgent()) return "Weighted scorecard results are calculated base on the business driver weightings that have been set for your Agency.  For more details, please contact your Agency Administrator.";
        return "Weighted scorecard results are calculated as follows: 55% weighting for Total Gross Adds Weighted Actuals/Quota; 25% weighting for Revenue Sales/Quota; 20% weighting for Upgrades Weighted Actuals/Quota";
    }

    getUserSupervisor(user) {
        var supervisor_id = this.getItemCustomFieldValue(user, "Supervisor ID");
        return (supervisor_id && this.adminService.getAllUsers()) ? this.adminService.getAllUsers().find(u => u.username == supervisor_id) : null;
    }

    processDealAction(action, data, content_type?: string): Observable<any> {
        return this.apiService.post(`/models/deal/action/${action}`, data, content_type).map(
            (result) => {
                return result;
            }
        )
    }

    // #region Daily campaign Intro SMS Details
    public isSmsIntroLimitEnabled(cfd_esil) {
        return cfd_esil == "Yes";
    }

    public daily_campaign_intro_sms_limit: number;
    public getDailyCampaignIntroSMSLimit(): Observable<any> {
        let params: any = {
            it: "client_preference",
            iid: 0,
            fn: "daily_campaign_intro_sms_limit"
        };
        return this.apiService.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    this.daily_campaign_intro_sms_limit = parseInt(result[0].field_value);
                }
                return this.daily_campaign_intro_sms_limit;
            }
        )
    }

    public isSameDate(date1: Date, date2: Date) {
        var is_same_date = date1.getDate() == date2.getDate() // date check
            &&
            date1.getMonth() == date2.getMonth() // month check
            &&
            date1.getFullYear() == date2.getFullYear(); // year check
        return is_same_date;
    }

    getTargetCampaignIntroSmsDetail(cm_ID) {
        var details_value = this.getItemCustomFieldValue(this.authService.getActive(), "Daily Campaign Intro SMS Details");
        var intro_sms_details = details_value ? JSON.parse(details_value) : [];
        var target_isd = null;
        intro_sms_details.forEach(isd => {
            if (isd.campaign_ID == parseInt(cm_ID)) {
                target_isd = isd;
            }
        })

        if (target_isd == null) {
            target_isd = {
                campaign_ID: cm_ID,
                intro_sms_count: 0,
                intro_sms_date: null,
            }
        }
        return target_isd;
    }

    updateCampaignIntroSmsDetails(target_isd) {
        var details_value = this.getItemCustomFieldValue(this.authService.getActive(), "Daily Campaign Intro SMS Details");
        var intro_sms_details = details_value ? JSON.parse(details_value) : [];
        intro_sms_details.forEach(isd => {
            if (isd.campaign_ID == target_isd.campaign_ID) {
                isd.intro_sms_count = target_isd.intro_sms_count;
                isd.intro_sms_date = target_isd.intro_sms_date;
                target_isd = null;
            }
        })
        if (target_isd != null) intro_sms_details.push(target_isd);

        return intro_sms_details;
    }

    public incrementDailyCampaignIntroSMSCount(cm_ID) {
        var target_isd = this.getTargetCampaignIntroSmsDetail(cm_ID);

        var is_same_date = target_isd.intro_sms_date ? this.isSameDate(new Date(target_isd.intro_sms_date), new Date()) : false;
        target_isd.intro_sms_count = target_isd.intro_sms_count && is_same_date ? target_isd.intro_sms_count + 1 : 1;
        target_isd.intro_sms_date = new Date();
        this.setItemCustomFieldValue(this.authService.getActive(), "Daily Campaign Intro SMS Details", JSON.stringify(this.updateCampaignIntroSmsDetails(target_isd)));
    }

    public isCampaignIntroLimitExceeded(cm_ID, cfd_esil, cfd_sms_limit): boolean {
        if (this.isSmsIntroLimitEnabled(cfd_esil)) {
            var target_isd = this.getTargetCampaignIntroSmsDetail(cm_ID);
            var is_same_date = target_isd.intro_sms_date ? this.isSameDate(new Date(target_isd.intro_sms_date), new Date()) : false;
            return is_same_date && target_isd.intro_sms_count >= parseInt(cfd_sms_limit);
        }
        return false;
    }
    // #endregion Daily campaign Intro SMS Details - end

    //#region P2W Other Results
    public p2w_other_results: any = null;
    public getP2WOtherResults(other_results_type: string, scope_type: string, scope_value: string, scope_month: string, bReload: boolean = false) {
        if (this.p2w_other_results == null || bReload) {
            return this.apiService.getViewData(this.view_p2w_other_results, { est: 'ST_Search', other_results_type: other_results_type, scope_type: scope_type, scope_value: scope_value, "SP_MONTH_SUBJECT": scope_month }).map(result => {
                return result.items;
            })
        } else {
            return this.p2w_other_results;
        }
    }

    public p2w_todays_other_results: any = null;
    public getP2WTodaysOtherResults(other_results_type: string, scope_type: string, scope_value: string, scope_month: string, bReload: boolean = false) {
        if (this.p2w_todays_other_results == null || bReload) {
            return this.apiService.getViewData(this.view_p2w_todays_other_results, { est: 'ST_Search', other_results_type: other_results_type, scope_type: scope_type, scope_value: scope_value, "SP_MONTH_SUBJECT": scope_month }).map(result => {
                return result.items;
            })
        } else {
            return this.p2w_todays_other_results;
        }
    }
    //#endregion

    convertPlanMonth(plan_month) {
        var year = plan_month.substring(0, 4);
        var month = this.calendarService.getMonthName(parseInt(plan_month.substring(4)) - 1);
        return `${month} ${year}`;
    }

    //#region welcome message
    private welcome_message: any = null;
    public wc_pid: number = -1;
    public getWelcomeMessage(): Observable<any> {
        if (this.welcome_message == null) {
            return this.adminService.processUserAction("get_welcome_messages", null, "raw").map(wc_project => {
                if (wc_project) {
                    this.wc_pid = this.projectService.addProjectToCollection(wc_project);
                    // ASSUMPTION: server will return only one deliverable if available
                    this.welcome_message = wc_project.project.deliverable;
                    //var deliverables = this.projectService.getAvailableDeliverables(this.wc_pid);
                    // TODO: determine welcome message deliverable
                    // if (deliverables && deliverables.length > 0) {
                    //     var wc_deliverable = null;
                    //     deliverables.forEach(d => {
                    //         if (wc_deliverable == null && this.projectService.isDeliverableVisible(this.wc_pid, d)) {
                    //             wc_deliverable = d;
                    //         }
                    //     })
                    //     this.welcome_message = wc_deliverable;
                    // }
                    return this.welcome_message;
                }
            })
        } else {
            return new Observable(observer => {
                observer.next(this.welcome_message);
                observer.complete();
            });
        }
    }

    public confirmWelcomeMessage(): void {
        var data = { project: JSON.stringify(this.welcome_message) };
        this.adminService.processUserAction("confirm_welcome_message_shown", data, "raw").subscribe(
            result => {
                this.projectService.updateProject(result, this.wc_pid);
                this.sessionService.log("confirm_welcome_message_shown successful");
            },
            err => {
                console.log('confirm_welcome_message_shown failed', err);
                this.sessionService.log("unable to confirm_welcome_message_shown");
            }
        )
    }
    //#endregion 

    //#region retail foundations
    private my_retail_foundations: any = null;
    private other_retail_foundations: any = null;
    public rf_pid: number = -1;
    public getRetailFoundations(rf_user_ID): Observable<any> {
        if (this.my_retail_foundations == null) {
            var params = rf_user_ID > 0 ? { rf_user_ID: rf_user_ID } : null;
            return this.adminService.processUserAction("get_retail_foundations", params, "raw").map(rf_project => {
                if (rf_project) {
                    if (rf_user_ID == null) {
                        this.my_retail_foundations = rf_project;
                        this.rf_pid = this.projectService.addProjectToCollection(rf_project);
                        return this.my_retail_foundations;
                    } else {
                        return rf_project;
                    }
                }
            })
        } else {
            return new Observable(observer => {
                observer.next(this.my_retail_foundations);
                observer.complete();
            });
        }
    }

    public updateRetailFoundations(rf_project) {
        this.my_retail_foundations = rf_project;
        this.projectService.updateProject(rf_project, this.rf_pid);
    }

    public completeRetailFoundationDeliverable(dlvb_ID): Observable<any> {
        var data = { dlvb_ID: dlvb_ID };
        return this.adminService.processUserAction("compelete_retail_foundation_deliverable", data, "raw").map(
            rf_project => {
                if (rf_project) {
                    this.projectService.updateProject(rf_project, this.rf_pid);
                    this.sessionService.log("compelete_retail_foundation_deliverable successful");
                    return rf_project;
                }
            },
            err => {
                console.log('compelete_retail_foundation_deliverable failed', err);
                this.sessionService.log("unable to compelete_retail_foundation_deliverable");
            }
        )
    }

    private gotoRetailFoundationsSubject = new ReplaySubject<any>(1);
    public gotoRetailFoundations = this.gotoRetailFoundationsSubject.asObservable();
    setRetailFoundations(ap) {
        this.gotoRetailFoundationsSubject.next(ap);
    }
    //#endregion     

    public is2022Q4Phase3Enabled() { return true; }
    public is2022Q4Phase4Enabled() { return !this.adminService.isClientCodeDefined('DQ4P234') && !this.adminService.isClientCodeDefined('DQ4P34') && !this.adminService.isClientCodeDefined('DQ4P4'); }

    //#region Awarded Users
    private awardedUsersSubject = new ReplaySubject<any>(1);
    public awardedUsers = this.todaysGoalSubject.asObservable();

    public awarded_users: any;
    public getAwardedUsers(bReload: boolean = false): Observable<any> {
        if (!bReload && this.awarded_users != null) {
            return new Observable(observer => {
                observer.next(this.awarded_users);
                observer.complete();
            });
        } else {
            return this.apiService.getViewData(this.view_p2w_awarded_users, null).map(result => {
                this.awarded_users = result.items;
                this.awardedUsersSubject.next(this.awarded_users);
                return this.awarded_users;
            });
        }
    }
    //#endregion

    //#region Store Visits Methods
    public getStoreVisitItemsByView(view: string, store_team_ID: string, sid: string = null): Observable<any> {
        var params = { 'SP_STORE_TEAM_ID': store_team_ID, est: "ST_Search", 'SP_STORE_ID': sid };
        return this.apiService.getViewData(view, params).map(result => {
            return result.items;
        })
    }

    public getSvtStoreUserByScope(): any[] {
        return this.store_visit_team_stores;
    }

    public svtCurrentStoreUser: any;
    private svtCurrentStoreSubject = new ReplaySubject<any>(1);
    public svtCurrentStore = this.svtCurrentStoreSubject.asObservable();
    public getCurrentStoreVisitStore() {
        return this.svtCurrentStoreUser;
    }

    public setSvtCurrentStore(store: any) {
        this.svtCurrentStoreUser = store;
        this.svtCurrentStoreSubject.next(store);
    }

    public clearSvtStoreCaches() {
        this.store_visit_team_stores = null;
        this.storeVisitTeamStoresSubject.next(null);
        this.setSvtCurrentStore(null);
    }

    public enabledStoreVisitLeaderView() {
        return this.isLeader();
        //return this.isLeader() && !this.isStoreMgrOrAssistant();
    }

    public isQueuingModuleAccessEnabled() {
        return true;
    }

    private storeVisitTeamStoresSubject = new ReplaySubject<any[]>(null);
    public storeVisitTeamStores = this.storeVisitTeamStoresSubject.asObservable();
    private store_visit_team_stores: any[] = [];

    loadStoreVisitTeamStores(bReload: boolean = false) {
        this.apiService.getViewData(this.view_store_visit_team_stores, { est: "ST_Search" }).subscribe(
            result => {
                this.store_visit_team_stores = result.items;
                this.storeVisitTeamStoresSubject.next(this.store_visit_team_stores);
            },
            err => {
                console.log(err);
            }
        );
    }
    //#endregion Store Visits Methods

    private user_sales_metrics;
    // get current user's sales metrics
    public loadUserP2WSalesMetrics(): Observable<any> {
        var params: any = { requested_metrics: '{"dataset_category":"p2w_sales_metrics"}' };
        return this.apiService.processUserActionOnGet("get_retail_portal_metric", params).map(result => {
            this.user_sales_metrics = result;
        })
    }

    public getP2WSalesMetrics(dataset_type: string, scope_type?: string, scope_value?: string): Observable<any> {
        var metrics_dataset_collection;
        if (this.isLeader()) {
            var scope = { scope_value: scope_value, scope_type: scope_type }
            if (this.team_sales_metrics_by_scope[JSON.stringify(scope)] == null) {
                return this.loadTeamP2WSalesMetrics(scope_type, scope_value).map(result => {
                    this.team_sales_metrics_by_scope[JSON.stringify(scope)] = result;
                    var sales_metrics = [];
                    result.forEach(m => {
                        if (m.dataset_type == dataset_type) {
                            sales_metrics.push(m);
                        }
                    })
                    return sales_metrics;
                })
            } else {
                metrics_dataset_collection = this.team_sales_metrics_by_scope[JSON.stringify(scope)];
            }
        } else {
            metrics_dataset_collection = this.user_sales_metrics;
        }

        var sales_metrics = [];
        metrics_dataset_collection.forEach(m => {
            if (m.dataset_type == dataset_type) {
                sales_metrics.push(m);
            }
        })

        // return sales_metrics;
        return new Observable(observer => {
            observer.next(sales_metrics);
            observer.complete();
        });
    }

    private team_sales_metrics_by_scope: any = {};
    // get current user team's sales metrics
    public loadTeamP2WSalesMetrics(scope_type?: string, scope_value?: string): Observable<any> {
        var scope = { scope_value: scope_value, scope_type: scope_type }
        if (scope_type == null) scope = this.getDefaultScope(this.authService.getActive());
        var params: any = { scope_type: scope.scope_type, scope_value: scope.scope_value, requested_metrics: '{"dataset_category":"p2w_sales_metrics"}' };
        return this.apiService.processUserActionOnGet("get_retail_portal_metric", params).map(result => {
            this.team_sales_metrics_by_scope[JSON.stringify(scope)] = result;
            return result;
        })
    }

    // title to scope_type mapping for COR, AGENT, TELESALES
    private title_to_scope_type_mapping = [
        // corporate mapping
        { title: "VP - Retail Sales and Operations", scope_type: "channel" },
        { title: "Area VP-General Mgr, Retail Sales & Ops", scope_type: "region" },
        { title: "Dir Retail Sales and Operations", scope_type: "territory" },
        { title: "Mgr Retail Area Sales", scope_type: "area" },
        { title: "Store Mgr I", scope_type: "store" },
        { title: "Store Mgr II", scope_type: "store" },
        { title: "Mgr Store", scope_type: "store" },
        { title: "Mgr Sales", scope_type: "store" },
        { title: "Assistant Manager", scope_type: "store" },
        // telesales mapping
        { title: "VP - Customer Support", scope_type: "channel" },
        { title: "Mgr Telesales", scope_type: "channel" },
        { title: "Telesales Supervisor", scope_type: "store" },
        // agent mapping
        { title: "Master", scope_type: "agency" },
        { title: "Admin/Manager of Agency", scope_type: "agency" },
        { title: "Area Manager", scope_type: "store" },
        { title: "Manager", scope_type: "store" },
    ];

    // generate the default scope (type and value) for specified user
    public getDefaultScope(user): any {
        var scope: any = {};
        var scope_user = user;
        var store_ID = this.getAssociateStoreID(scope_user);
        // var store_ID = this.getItemCustomFieldValue(scope_user, "TopsID");
        var scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
        if (scope_mapping == null) {
            scope_user = this.getUserSupervisor(user);
        }
        if (scope_user) {
            // HACK: it is possible that the current team leader (AVP/DOS/MRAS) are placeholder user accounts
            //       therefore, the lastname of the account would be the position number, which is used to generate the dataset (sales vs quota/goal)
            scope.scope_value = this.conditionService.isNumeric(scope_user.last_name) ? scope_user.last_name : scope_user.first_name + ' ' + scope_user.last_name;
            // double check the scope_user title again         
            scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
            if (scope_mapping) scope.scope_type = scope_mapping.scope_type;
            // telesales supervisors have channel scope
            if (scope.scope_type == "channel" && this.isUSCellTelesales()) scope.scope_value = "Telesales";
            if (scope.scope_type == "agency") scope.scope_value = this.getAgencyNameByUser(user);
            if (scope.scope_type == "store" && store_ID) {
                // if failed again, the this user must be in the scope_type = store            
                scope.scope_value = this.getStoreNameByStoreID(store_ID);
                scope.scope_type = "store";
            }
        }
        return scope;
    }

    private payout_estimator_metrics_by_scope: any = {};
    public getPayoutEstimatorMetrics(action_plan_type: string, scope_type?: string, scope_value?: string): Observable<any> {
        var scope:any = { scope_type: scope_type }
        if (scope_value) scope.associate = scope_value;
        if (action_plan_type) scope.action_plan_type = action_plan_type;
        var params: any = { scope_type: scope_type, action_plan_type: action_plan_type, requested_metrics: '{"dataset_category":"payout_estimator_metrics"}' };
        if (scope_value) params.associate = scope_value;

        if (this.payout_estimator_metrics_by_scope[JSON.stringify(scope)] == null) {
            return this.apiService.processUserActionOnGet("get_retail_portal_metric", params).map(result => {
                this.payout_estimator_metrics_by_scope[JSON.stringify(scope)] = result;
                return result;
            })
        } else {
            // return sales_metrics;
            return new Observable(observer => {
                observer.next(this.payout_estimator_metrics_by_scope[JSON.stringify(scope)]);
                observer.complete();
            });            
        }
    }

    public getAssociateStoreID(associate) {
        var store_ID = this.getItemCustomFieldValue(associate, "TopsID");
        if (this.isUSCellAgent()) {
            var primary_location = this.getItemCustomFieldValue(associate, "Primary Location");
            if (primary_location && associate.team_name.indexOf(primary_location) >= 0) {
                store_ID = primary_location;
            } else {
                var additional_locations = this.getItemCustomFieldValue(associate, "Additional Locations");
                additional_locations = additional_locations.replace('[', '').replace(']', '');
                var store_IDs = additional_locations.split(',');
                store_IDs.forEach(id => {
                    if (id.trim() != '' && associate.team_name.indexOf(id.trim()) >= 0) {
                        store_ID = id.trim();
                    }
                })
            }
        }
        return store_ID;
    }

    getAgencyNameByUser(user) {
        var agency = '';
        if (this.isUSCellAgent()) {
            var team_IDs = user.team_key_ID.split('_');
            var agency_team_ID = team_IDs.find(id => id != '' && id != '1367');  // find() returns the first match, thus this will return the 2nd team_ID after the root_team_ID=1367, which would be the agency team ID
            var agency_user = this.adminService.getAvailableUsers().find(u => u.team_ID == parseInt(agency_team_ID));
            if (agency_user) agency = agency_user.team_name;
        }
        return agency;
    }

    // In Agent- Master Agent hierarchy, only agency team users are required to make the session functional
    loadAgencyTeamUsers(user: User, exclude_up_timezone:string = "Y") {
        var team_IDs = user.team_key_ID.split('_');
        var agency_team_ID = team_IDs.find(id => id != '' && id != '1367');  // find() returns the first match, thus this will return the 2nd team_ID after the root_team_ID=1367, which would be the agency team ID
        this.adminService.loadScopeTeamUsers(agency_team_ID);
    }

    //{{local_base_url}}/Salesnow.svc/models/user/action/get_retail_portal_info?info_type=last_sales_extract
    public last_sales_extract;
    getLastSalesExtract() {
        var params: any = { info_type: 'last_sales_extract' };
        return this.apiService.processUserActionOnGet("get_retail_portal_info", params).map(result => {
            this.last_sales_extract = result[0].last_sales_extract;
        })
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/usc-store/usc-store.service.ts